/* eslint-disable max-len */

export default {
  errors: {
    global: {
      internal: 'Erreur interne',
      not_allowed: 'Action non autorisée',
      access_denied: 'Accès refusé',
      validator_error: 'Erreur de validation {details}',
      wrong_body: 'Mauvais groupe',
      wrong_token: 'Mauvais token',
      missing_token: 'Token manquant',
      exclusive_lock: 'Verouillage exclusif',
      access_denied_acl: 'Accès refusé (ACL)',
      connection_timeout: 'Délai de connexion dépassé',
      login_required: 'Identifiant requis',
      not_found: 'Non trouvé',
      wrong_value: 'Mauvaise valeur',
      token_expired: 'Token expiré',
      service_not_available: 'Service non disponible',
      twofa_required: 'A2F nécessaire',
      missing_login_token: 'Identifiant requis',
    },
    account: {
      banned: 'Compte banni',
      wrong_login_or_password: 'Mauvais identifiant ou mauvais mot de passe',
      wrong_login: 'Mauvais identifiant',
      wrong_password: 'Mauvais mot de passe',
      blocked: 'Compte bloqué',
      missing_email: 'Adresse e-mail non attribuée',
      same_password_used: 'Vous avez déjà utilisé ce mot de passe',
      apikey_not_created: 'Clé API non créée',
      apikey_already_created: 'Clé API déjà créee',
      twofa_not_created: 'A2F non crée',
      twofa_already_created: 'A2F déjà crée',
      deletion_already_started: 'La suppression du compte a déjà été entamée',
      wrong_twofa: 'Code A2F incorrect',
      external_withdraw_not_available: 'Le retrait externe n\'est pas disponible',
      twofa_limit: 'Limite A2F',
      kyc_wrong_step: 'Mauvaise étape KYC',
      not_exists: 'N\'existe pas',
      kyc_required: 'KYC requis',
      action_not_allowed: 'Action non autorisée',
      migration: 'Migration',
      wrong_password_pattern: 'Le mot de passe doit comporter entre 8 et 64 caractères et inclure au moins une majuscule, une minuscule, un chiffre et un caractère spécial',
    },
    market: {
      not_enough_funds: 'Fonds insuffisants',
      missing_steam_token: 'Trade URL Steam manquant',
      missing_steam_id: 'Steam ID manquant',
      wrong_item_status: 'Statut de l\'item incorrect',
      item_already_queued: 'Item déjà en attente',
      max_price_limit: 'Limite maximale du prix',
      item_not_available: 'Item non disponible',
      steam_vac_ban: 'Steam VAC ban',
      steam_trade_ban: 'Steam trade ban',
      steam_private_profile: 'Profil privé Steam',
      steam_private_inventory: 'Inventaire privé Steam',
      steam_tradehold: 'Steam trade en attente',
      cannot_check_tradeban: 'Impossible de vérifier le trade ban',
      cannot_check_tradehold: 'Impossible de vérifier le trade en attente',
      wrong_steam_token: 'Mauvais token Steam',
      no_items_found: 'Aucun item n\'a été trouvé',
      items_limit: 'Limite d\'items',
      instant_sell_disabled: 'Vente instantanée désactivée',
      plan_not_found: 'Plan non trouvé',
      price_too_low: 'Prix trop bas',
      queue_full: 'La file d\'attente de retrait d\'items est pleine, réessayez plus tard.',
    },
    steam: {
      wrong_tradelink: 'Mauvais trade link',
      private_inventory: 'Inventaire privé Steam',
      cannot_check_tradeban: 'Nous ne pouvons pas vérifier le trade ban',
      cannot_check_tradehold: 'Nous ne pouvons pas vérifier le trade en attente',
      vac_ban: 'VAC ban',
      trade_ban: 'Trade ban',
      private_profile: 'Profil Steam privé',
      tradehold: 'Trade en attente',
      wrong_token: 'Token incorrect',
      missing_token: 'Trade url steam manquant',
      missing_steam_id: 'Steam ID manquant',
      community_ban: 'Ban de la communauté',
      economy_ban: 'Economy ban',
      platform_offline: 'Aucune connexion avec Steam, les serveurs sont peut-être en panne. Veuillez réessayer plus tard.',
      cannot_check_escrow: 'Le dépôt fiduciaire ne peut pas être vérifié',
      escrow: 'Vous utilisez Steam Guard par e-mail, ce qui n\'est pas suffisant pour trade avec nos bots. Vous devez activer Steam Guard mobile pour pouvoir trade avec nos bots.',
      fresh_account: 'Vous devez d\'abord configurer votre profil Steam.',
    },
    mutex: {
      long_lock: 'Verrouillage prolongé, réessayez dans {ttl} secondes',
      exclusive_lock: 'Verrouillage exclusif',
    },
    api: {
      missing_apikey: 'Clé API manquante',
      missing_secret: 'Clé API Secrète manquante',
      wrong_ip_address: 'Adresse IP incorrecte',
      private_ip_address: 'Adresse IP privée',
      wrong_apikey: 'Clé API incorrecte',
    },
    record: {
      item_not_found: 'Item non trouvé',
      item_not_owned: 'Item non possédé',
      own_item: 'Votre item',
      there_are_no_records: 'Aucun enregistrement disponible',
      record_already_exists: 'L\'enregistrement existe déjà',
      record_not_exists: 'L\'enregistrement n\'existe pas',
      already_exists: 'Existe déjà',
      not_exists: 'N\'existe pas',
      not_updated: 'Non à jour',
      forbidden: 'Interdit',
    },
    bot: {
      not_found: 'Bot introuvable',
      not_available: 'Bot non disponible',
    },
    wallet: {
      cannot_transfer_money: 'Impossible de transférer de l\'argent',
      amount_negative: 'Montant négatif',
      amount_positive: 'Montant positif',
      card_scoring_too_low: 'Le solde de la carte est trop faible',
      not_enough_balance: 'Pas assez de solde',
      kyc_window_limit: 'Limite de fenêtre KYC',
      service_window_limit: 'Limite de fenêtre de service',
      amount_limit: 'Limite de montant',
      wrong_wallet_address: 'Mauvaise adresse du portefeuille',
      card_not_found: 'Carte non trouvée',
      cannot_process_transaction: 'Nous ne pouvons pas traiter votre transaction',
      only_past_months_accepted: 'Seuls les mois passés sont acceptés.',
      only_visa_allowed: 'Seules les cartes VISA sont autorisées',
      you_cannot_complete_this_action: 'Vous ne pouvez pas effectuer cette action car votre compte n\'est pas suffisamment approvisionné.',
      you_need_to_deposit_at_least_x: 'Vous devez déposer au moins {x} pour effectuer cette action.',
    },
    gift_code: {
      not_found: 'Code non trouvé',
      already_used: 'Code déjà utilisé',
      own_code: 'Ceci est votre propre code',
    },
    partner: {
      subaccount_not_enabled: 'Le sous-compte n\'est pas activé',
      link_account_first: 'Lier d\'abord le compte',
      account_already_linked: 'Compte déjà lié',
      wrong_phrase: 'Phrase incorrecte',
      cannot_link_yourself: 'Impossible de se lier soi-même',
      account_already_exists: 'Le compte existe déjà',
    },
    payment: {
      card_scoring: 'Le solde de la carte est trop faible',
      payment_issue: 'Problème de paiement',
    },
    auth: {
      failed_to_authenticate: 'Échec de l\'authentification',
      not_valid_identity: 'Identité non valide',
      authentication_failed: 'Échec de l\'authentification',
    },
    social: {
      cannot_create_chat: 'Impossible de créer un chat',
    },
    support: {
      wrong_status: 'Statut incorrect',
      ticket_limit: 'Limite de ticket dépassée',
    },
    ipn: {
      verification_issue: 'Problème de vérification',
    },
    affiliate: {
      same_code: 'Code identique',
      code_taken: 'Ce code est déjà utilisé',
      not_activated: 'Non activé',
      not_enough_balance: 'Pas assez de solde',
    },
    bam: {
      bam_steam_015: 'Nos bots ont perdu la connexion avec Steam. Veuillez réessayer dans quelques minutes.',
    },
  },
  validator: {
    required: 'Ce champ est obligatoire.',
    string: 'Ce champ doit être une chaîne de caractères.',
    stringEmpty: 'Ce champ ne doit pas être vide.',
    stringMin: 'La longueur de ce champ doit être d\'au moins {expected} caractères.',
    stringMax: 'La longueur de ce champ doit être au maximum de {expected} caractères.',
    stringLength: 'La longueur de ce champ doit être de {expected} caractères.',
    stringPattern: 'Ce champ ne correspond pas au modèle attendu.',
    stringPatternLatin: 'Veuillez utiliser uniquement des caractères latins.',
    stringContains: 'Ce champ doit contenir le texte "{expected}".',
    stringEnum: 'Ce champ ne correspond à aucune des valeurs autorisées.',
    stringNumeric: 'Ce champ doit être une chaîne numérique.',
    stringAlpha: 'Ce champ doit être une chaîne alphabétique.',
    stringAlphanum: 'Ce champ doit être une chaîne alphanumérique.',
    stringAlphadash: 'Ce champ doit être une chaîne alphadash.',
    stringHex: 'Ce champ doit être une chaîne hexagonale.',
    stringSingleLine: 'Ce champ doit être une chaîne de caractères d\'une seule ligne.',
    stringBase64: 'Ce champ doit être une chaîne en base64.',
    number: 'Ce champ doit être un nombre.',
    numberMin: 'Ce champ doit être supérieur ou égal à {expected}.',
    numberMax: 'Ce champ doit être inférieur ou égal à {expected}.',
    numberEqual: 'Ce champ doit être égal à {expected}.',
    numberNotEqual: 'Ce champ ne peut pas être égal à {expected}.',
    numberInteger: 'Ce champ doit être un nombre entier.',
    numberPositive: 'Ce champ doit être un nombre positif.',
    numberNegative: 'Ce champ doit être un nombre négatif.',
    array: 'Ce champ doit être un tableau.',
    arrayEmpty: 'Ce champ ne doit pas être un tableau vide.',
    arrayMin: 'Ce champ doit contenir au moins les items {expected}.',
    arrayMax: 'Ce champ doit contenir un nombre d\'items inférieur ou égal à {expected}.',
    arrayLength: 'Ce champ doit contenir {expected} items.',
    arrayContains: 'Ce champ doit contenir l\'item "{expected}".',
    arrayUnique: 'La valeur "{actual}" n\'est pas unique aux valeurs "{expected}".',
    arrayEnum: 'La valeur "{actual}" ne correspond à aucune des valeurs "{expected}".',
    tuple: 'Ce champ doit être un tableau.',
    tupleEmpty: 'Ce champ ne doit pas être un tableau vide.',
    tupleLength: 'Ce champ doit contenir {expected} items.',
    boolean: 'Ce champ doit être un booléen.',
    currency: 'Ce champ doit correspondre à un format de devise valide',
    date: 'Ce champ doit être une date.',
    dateMin: 'Ce champ doit être supérieur ou égal à {expected}.',
    dateMax: 'Ce champ doit être inférieur ou égal à {expected}.',
    enumValue: 'La valeur du champ "{expected}" ne correspond à aucune des valeurs autorisées.',
    equalValue: 'La valeur de ce champ doit être égale à "{expected}".',
    equalField: 'La valeur de ce champ doit être égale à la valeur du champ "{expected}".',
    forbidden: 'Ce champ est interdit.',
    function: 'Ce champ doit être une fonction.',
    email: 'Ce champ doit être un e-mail valide.',
    emailEmpty: 'Ce champ ne doit pas être vide.',
    emailMin: 'La longueur de ce champ doit être d\'au moins {expected} caractères.',
    emailMax: 'La longueur de ce champ doit être au maximum de {expected} caractères.',
    luhn: 'Ce champ doit comporter un chiffre de contrôle Luhn valide.',
    mac: 'Ce champ doit être une adresse MAC valide.',
    object: 'Ce champ doit être un Objet.',
    objectStrict: 'Cet objet contient des clés interdites : "{actual}".',
    objectMinProps: 'Cet objet doit contenir au moins les propriétés {expected}.',
    objectMaxProps: 'Cet objet doit contenir au maximum des propriétés {expected}.',
    url: 'Ce champ doit être une URL valide.',
    urlEmpty: 'Ce champ ne doit pas être vide.',
    uuid: 'Ce champ n\'est pas un format de code valide.',
    uuidVersion: 'Ce champ doit être une version valide de l\'UUID fournie.',
    classInstanceOf: 'Ce champ doit être une instance de la classe "{expected}".',
    objectID: 'Ce champ doit être un ObjectID valide',
    record: 'Ce champ doit être un Objet.',
  },
  body: {
    language: 'Langue',
    currency: 'Devise',
    currency_warning: 'Toutes les opérations sont effectuées en dollars américains. Les devises autres que l\'USD sont converties à partir de l\'USD et ne modifient que la façon dont la page est visualisée. Les variations des taux de change peuvent augmenter ou diminuer votre solde.',
    choose_game: 'Choisir un jeu',
    slider: {
      title_1: 'Améliorez votre style,',
      title_2: 'dominer le jeu',
      content_1: 'Découvrez la collection ultime de skins',
      content_2: 'Pour améliorer votre expérience de jeu.',
      tile_1: 'Maximisez votre expérience de jeu',
      tile_2: 'Obtenez le meilleur rapport qualité/prix',
      tile_3: 'Bénéficier d\'échanges sécurisés et en continu',
    },
    footer_description: 'Chez BitSkins, nous nous sommes engagés à fournir une plateforme sûre et sécurisée permettant aux joueurs d\'acheter et de vendre des items issus de jeux populaires tels que CS2, Dota 2, Rust et TF2. Depuis notre lancement en 2015, nous avons servi avec succès des millions de clients satisfaits, et notre engagement en matière de sûreté et de sécurité reste plus fort que jamais.',
    footer_disclaimer: '© 2015 - {year} BitSkins. Propulsé par Steam. Non affilié à Valve Corp.',
    footer_email_support: 'Si vous avez besoin d’aide',
    footer_email_security: 'Si vous voulez signaler des bugs',
    footer_email_partnership: 'Si vous souhaitez collaborer avec nous',
    market: 'Marché',
    cart: 'Panier',
    cart_empty: 'Votre panier est vide',
    clear_cart: 'Vider le panier',
    checkout: 'Paiement',
    in_the_cart: 'dans le panier',
    total: 'Total',
    go_to_market: 'Accéder au marché',
    trustpilot_alt: 'Trustpilot avec {stars} étoiles et {reviews} avis',
    reload_website: 'Actualisez le site !',
    app_error: 'Erreur d\'application : {error}',
    latest_articles: 'Derniers articles',
    steam_login: 'Connexion à Steam',
  },
  maintenance: {
    we_will_be_back_soon: 'Nous reviendrons bientôt',
    we_are_down_for_maintenance: 'Nous sommes interrompus pour maintenance, mais nous serons de nouveau en ligne sous peu.',
    sorry_for_the_inconvenience: 'Nous sommes désolés pour ce désagrément et vous disons à bientôt !',
  },
  account: {
    email: {
      required: 'L\'adresse e-mail est requise',
      required_for_this_payment_method: 'Vous ne pouvez pas utiliser ce mode de paiement car vous n\'avez pas configuré votre adresse e-mail.',
      you_can_start_now: 'Vous pouvez maintenant lancer le processus d\'installation.',
      setup: 'Configuration de l\'e-mail',
    },
    add_funds: 'Ajouter des fonds',
    my_store: 'Mon magasin',
    selling: 'Vente',
    transactions: 'Transactions',
    settings: 'Paramètres',
    steam_settings: {
      open_settings: 'Ouvrir les paramètres',
      open_steam_settings: 'Ouvrir le profil Steam',
      what_is_steam_guard: 'Qu\'est-ce que Steam Guard ?',
      inventory_status: 'Statut de votre inventaire',
      profile_status: 'Statut du profil',
      change_trade_link: 'Modifier le trade link',
    },
    logout: 'Déconnexion',
    inventory: 'Inventaire',
    banned: {
      you_are_banned: 'Vous êtes <span class="text-cr">banni</span>',
      your_account_has_been_banned: 'Votre compte a été banni pour avoir enfreint notre',
      your_account_has_been_blocked: 'Votre compte a été bloqué pour avoir enfreint notre',
      if_you_believe: 'Si vous pensez qu\'il s\'agit d\'une erreur, vous pouvez nous contacter à <span class="text-cp">support{\'@\'}bitskins.com</span>',
      terms_of_use: 'Conditions d\'Utilisation',
    },
    account_blocked: 'Compte <span class="text-cr">bloqué</span>',
    api_access: 'Accès à l\'API',
  },
  balance: {
    wallet: 'Portefeuille',
    withdraw: 'Retrait',
    withdraw_to: 'Retrait vers',
    withdraw_again: 'Refaire un retrait',
    withdrawable: 'Retirable',
    total: 'Total',
    balance: 'Solde',
    deposits_and_sales: 'Dépôts et ventes',
    proceeds_from_sales: 'Gains des ventes',
    deposit: 'Dépôt',
    locked: 'Verrouillé',
    funds_locked: 'Fonds verrouillé pour vos transactions',
    pending_withdrawals: 'Retraits en attente',
    thank_you_for_your_payment: 'Merci pour votre achat',
    your_money_will_arrive_soon: 'Votre argent va arriver dans les plus bref délais',
    your_payment_is_still_processing: 'Votre paiement est en cours de traitement, mais vos fonds devraient apparaître sur votre compte sous peu.',
    in_case_you_do_not_receive: 'Si vous n\'avez pas reçu vos fonds dans les 15 prochaines minutes, veuillez contacter le support.',
    payment_pending: 'Paiement <span class="text-cbs">en attente</span>',
    payment_failed: 'Paiement <span class="text-cr">échoué</span>',
    payment_canceled: 'Paiement <span class="text-cg">annulé</span>',
    payment_has_been_cancelled: 'Le paiement a été annulé comme demandé',
    unfortunately_we_were_unable: 'Malheureusement, nous n\'avons pas pu traiter votre paiement.',
    please_try_again: 'Veuillez réessayer',
    if_the_problem_persists: 'Si le problème persiste, veuillez contacter notre support. Vous pouvez également essayer d\'utiliser une autre méthode de paiement.',
    back_to_wallet: 'Retour au portefeuille',
    total_description: 'Les fonds provenant de vos dépôts et de vos ventes.',
    withdrawable_description: 'Le total des ventes. Ces fonds peuvent être retirés ou dépensés pour l\'achat d\'items.',
    locked_description: 'Fonds temporairement bloqués qui ne peuvent être ni dépensés ni retirés. La raison pour laquelle les fonds sont bloqués est due aux ordres d\'achat existants, à l\'achat d\'items, etc...',
    deposit_with_cryptocurrencies: 'Dépôt avec de la <span class="text-cp">crypto-monnaies :</span>',
    deposit_with_standard_payment_methods: 'Dépôt avec les <span class="text-cp">méthodes de paiement standard :</span>',
    withdraw_with_cryptocurrencies: 'Retraits en <span class="text-cp">crypto-monnaie :</span>',
    withdraw_with_standard_payment_methods: 'Retrait en <span class="text-cp">méthodes de paiement habituelles :</span>',
    your_amount: 'Votre montant',
    your_limit: 'Votre limite',
    your_limits: 'Vos limites',
    increase_your_limits: 'Augmentez vos limites',
    payment_not_available_in_the_following_countries: 'Ce mode de paiement n\'est pas disponible dans les pays suivants :',
    the_price_is_updated_every_60_seconds: 'Le prix est mis à jour toutes les 60 secondes et il s\'agit du prix moyen collecté auprès de plusieurs échanges.',
    rate_includes_x_fee: 'Le taux inclut un frais de {x}%.',
  },
  not_found: {
    title: 'Page non trouvée',
    message: 'Il semble que vous soyez perdu. Vous pouvez trouver les<br>skins de vos rêves sur la page du marché.',
  },
  login: {
    welcome_to_bitskins: '<span class="text-cp">Bienvenue</span> sur BitSkins',
    sign_in: 'Se connecter',
    sign_up: 'S\'inscrire',
    rules_text: 'Je confirme que j\'ai 18 ans ou plus et j\'accepte les conditions suivantes :',
    sign_in_with_steam: 'Se connecter avec Steam',
    sign_up_with_steam: 'S\'inscrire avec Steam',
    email: 'E-mail',
    password: 'Mot de passe',
    already_have_an_account: 'Vous avez déjà un compte ? Cliquez ici',
    to_login: 'pour se connecter',
    to_login_via_email: 'pour se connecter par e-mail',
    login_via_email: 'Connexion par E-mail',
    log_in_using_your_email: 'Connectez-vous en utilisant votre e-mail et votre mot de passe.',
    forgot_password: 'Mot de passe oublié ?',
    login_via_steam: 'CONNEXION VIA STEAM',
    register_first: 'Vous devez d\'abord vous inscrire',
    passwords_not_migrated: 'Malheureusement, lors de la récente mise à jour, nous n\'avons pas pu migrer votre mot de passe, vous devrez donc le réinitialiser.',
  },
  common: {
    monthly: 'mensuel',
    x_to_y: 'de {x} à {y}',
    minimum_x: 'Minimum {x}',
    maximum_x: 'Maximum {x}',
    click: 'Cliquer',
    claim: 'Réclamer',
    or: 'ou',
    and: 'et',
    confirm: 'Confirmer',
    continue: 'Continuer',
    cancel: 'Annuler',
    enable: 'Activer',
    enabled: 'activé',
    disable: 'Désactiver',
    disabled: 'désactivé',
    download: 'Télécharger',
    twofa: 'Authentification à deux facteurs',
    terms_of_use: 'Conditions d\'Utilisation',
    privacy_policy: 'Politique de Confidentialité',
    cookie_policy: 'Politique de Cookies',
    about_us: 'À propos de nous',
    changelog: 'Changelog',
    faq: 'FAQ',
    support: 'Support',
    affiliate: 'Affiliation',
    blog: 'Blog',
    careers: 'Carrières',
    api: 'API',
    service_status: 'État du service',
    loading: 'Chargement...',
    buy_skins: 'Acheter des skins',
    sell_skins: 'Vendre des skins',
    popular: 'Populaire',
    skin_categories: 'Catégories de skin',
    payments: 'Paiements',
    about_bitskins: 'À propos de BitSkins',
    social_media: 'Nos réseaux sociaux',
    follow_us: 'Suivez-nous et rejoignez notre communauté !',
    enter_your_email: 'Saisissez votre adresse e-mail',
    phone_number: 'N° de téléphone',
    verify: 'Vérifier',
    add: 'Ajouter',
    update: 'Mise à jour',
    check_spam_folder: 'Si vous ne trouvez pas l\'e-mail dans votre boîte de réception, veuillez vérifier votre dossier spam.',
    here: 'ici',
    edit: 'éditer',
    save: 'sauvegarder',
    copy: 'copier',
    back: 'Retour',
    back_to_login: 'Retour au login',
    clear: 'Clair',
    quantity: 'Quantité',
    name: 'Nom',
    bot_name: 'Nom du bot',
    steam: 'Steam',
    steam_id: 'Steam ID',
    steam_group: 'Groupe Steam',
    browser: 'Navigateur',
    on: 'On',
    off: 'Off',
    hidden: 'Caché',
    empty: 'Vide',
    expires_in: 'Expire dans',
    member_since: 'Membre depuis',
    close: 'Fermer',
    paint_seed_value: 'Paint seed : {value}',
    error: 'Erreur',
    retry: 'Réessayez',
    no_options_available: 'Aucune option disponible',
    search: 'Recherche',
    any: 'Tout',
    min: 'Min',
    max: 'Max',
    no_limit: 'Aucune limite',
    scroll_left: 'Scrollez à gauche',
    scroll_right: 'Scrollez à droite',
    load: 'Charger',
    delete: 'Supprimer',
    remove: 'Retirer',
    all: 'Tous',
    game: 'Jeu',
    reset: 'Réinitialiser',
    in: 'dans',
    optional: '(optionnel)',
    default: 'Par défaut',
    filter: 'Filtre',
    up_to: 'Jusqu\'à',
    similar: 'Similaire',
    important: 'Important',
    step: 'Étape',
    share_link: 'Lien de partage',
    zoom: 'Zoom',
    found: 'Trouvé',
    try_again: 'Réessayez',
    of: 'de',
    timer: 'Minuteur',
    add_new: 'Ajouter un nouveau',
    and_more: 'ET PLUS ENCORE',
    check_status: 'Vérifier le statut',
    resend_link: 'Renvoyer le lien',
    back_to_home: 'Retour à la page d\'accueil',
    data_visible_only_to_logged_in_users: 'Ces données ne sont visibles que pour les utilisateurs connectés',
    login: 'Connexion',
    level: 'Niveau',
    twofa_code: 'Code A2F',
    id: 'ID',
    position: 'Position',
    amount: 'Montant',
    progressive_sum: 'Montant progressif',
    date: 'Date',
    active: 'Actif',
    yes: 'Oui',
    no: 'Non',
  },
  notifications: {
    change: 'Modifier',
    setup: 'Configuration',
    disconnect: 'Déconnexion',
    connect: 'Connexion',
    notifications: 'Notifications',
    notifications_center: 'Centre de notifications',
    clear_all: 'Effacer toutes les notifications',
    notifications_channels: 'Canaux de notifications',
    connected: 'Connecté',
    all_notifications: 'Toutes les notifications',
    sound: 'Son',
    volume_mute: 'Muet',
    volume_full: 'Volume au maximum ',
    all_sounds: 'Tous les sons :',
    off: 'On',
    on: 'Off',
    steam_issues_title: 'Problème avec Steam',
    steam_issues_content: 'Steam rencontre actuellement des problèmes qui pourraient affecter les trades, les empêchant d\'être traités ou créés.',
    name: {
      account_new_login: 'Nouvelle connexion au compte',
      inventory_sold: 'Inventaire vendu',
      inventory_buyorder: 'Ordre d\'achat de l\'inventaire',
      wallet_deposit_done: 'Dépôt réussi',
      support_new_reply: 'Nouvelle réponse du support ',
      support_ticket_closed: 'Ticket fermé',
      inventory_bargain_received: 'Négociation d\'inventaire reçue',
    },
  },
  market: {
    non_scraped_only: 'Non gratté uniquement',
    set_price: 'Fixer un prix',
    game_not_found: 'Jeu non trouvé',
    game_not_available: 'Jeu actuellement non disponible',
    any_stickers: 'Tous les autocollants',
    item_removed_from_sale: 'Item retiré de la vente',
    price_updated: 'Prix actualisé',
    item_withdrawn: 'Cet item a été retiré',
    go_to_withdrawn: 'Aller aux items retirés',
    item_issue: 'Nous avons un problème avec cet item',
    item_in_deposit_queue: 'Cet item est dans la file d\'attente des dépôts',
    item_in_withdraw_queue: 'Cet item est dans la file d\'attente de retrait',
    go_to_queued: 'Accéder aux items en attente',
    item_in_bitskins_inventory: 'Cet item se trouve dans votre inventaire BitSkins',
    go_to_inventory: 'Accéder à l\'inventaire',
    go_to_issue: 'Aller aux questions',
    maximum_price: 'Prix maximum',
    minimum_price: 'Prix minimum',
    average_price: 'Prix moyen',
    amount_sold: 'Montant vendu',
    withdrawal_batch_info: 'Veuillez noter que nous envoyons les items par lots toutes les minutes.',
    queued: 'En attente',
    queued_description: 'Vous trouverez ici les items qui sont en attente d\'un retrait ou d\'un dépôt.',
    withdrawn: 'Retiré',
    withdrawn_description: 'Vous trouverez ici les items qui ont été retirés.',
    issues: 'Problèmes',
    issues_description: 'Vous trouverez ici les items pour lesquels nous rencontrons des problèmes. Nous travaillons actuellement à la résolution de ces problèmes.',
    max_items_selected: 'Vous ne pouvez pas sélectionner plus d\'items que {limit}',
    item_status: 'Statut de l\'item',
    search_for_stickers: 'Rechercher des autocollants',
    this_item: '(cet item)',
    no_items_found: {
      no_items_found: 'Aucun item trouvé',
      no_items_found_span: 'Aucun item <span>trouvé</span>',
      we_could_not_find_any_offers: 'Nous n\'avons trouvé aucune offre',
      for: 'pour',
      this_can_be_due_to_applied_filters: 'Cela peut être dû aux filtres appliqués. Vous pouvez supprimer tous les filtres en cliquant sur le bouton ci-dessous',
    },
    only_tradable_items: 'Uniquement les items échangeables',
    not_accepting: 'Non accepté',
    sell: 'Vendre',
    skin: 'Skin',
    items: 'items',
    items_v2: 'items',
    buy_orders: 'Ordres d\'achat',
    search_for: 'Rechercher un item {game}',
    search_for_items: 'Rechercher un item',
    reload: 'Recharger',
    item_name: 'Nom de l\'item',
    enter_item_name: 'Saisissez le nom de l\'item',
    price: 'Prix',
    reset: 'Réinitialiser',
    all_items: 'Tous les items',
    sort: 'Filtrer',
    add_sort: 'Ajouter un filtre',
    steam_price: 'Prix steam',
    reference_price: 'Prix de référence',
    steam_inventory: 'Inventaire Steam',
    your_steam_inventory: 'Votre inventaire Steam',
    bitskins_inventory: 'Inventaire BitSkins',
    your_bs_inventory: 'Votre inventaire bitskins {extra}',
    refresh: 'Actualiser',
    learn_how_to_sell: 'Apprendre à vendre',
    select_1_by_1: 'Sélectionnez 1 par 1',
    select_all: 'Tout sélectionner',
    selected_items: 'Items sélectionnés',
    items_amount: '{count} items',
    offers: 'offres',
    favorites: 'Favoris',
    last: 'Dernièrement',
    viewed: 'consulter',
    same_price: {
      same_price_for: 'Même prix pour',
      all_items: 'Tout les items',
    },
    save_all: 'Tout sauvegarder',
    trade_hold: {
      name: 'Trade hold',
      between: 'Bloqué entre {min} et {max} jours',
      less: 'Bloqué depuis moins de {value} jours',
      any: 'Tous les trade hold',
      none: 'Pas de trade hold',
      withdrawable_in_days_hours: 'Retirable en {days} jours, {hours} heures',
      withdrawable_in_hours_minutes: 'Retirable en {hours} heures, {minutes} minutes',
      tradable: 'Échangeable',
    },
    filter: {
      status: 'Statut',
      date_from: 'Date du',
      date_to: 'Date au',
      amount_from: 'Montant de',
      amount_to: 'Montant à',
      price_from: 'Prix à partir de',
      price_to: 'Prix à',
      service: 'Service',
      item: 'Item',
      game: 'Jeu',
      type: 'Type',
      quality: 'Qualité',
      exterior: 'Extérieur',
      category: 'Catégorie',
      collection: 'Collection',
      color: 'Couleur',
      family: 'Famille de skin',
      phase: 'Phase',
      rarity: 'Rareté',
      grade: 'Grade',
      killstreak: 'Killstreak',
      effect: 'Effet',
      hero: 'Hero',
      nametag: 'Étiquette',
      hightier: 'High Tier',
      stickers: 'Autocollants',
      slot: 'Emplacement {value}',
      paint_seed: 'Paint seed',
      paint_index: 'Paint index',
      sticker_counter: 'Nombre d\'autocollants',
      float_value: 'Float',
      active: '{value} actif',
      by_slot_position: 'Par position du créneau',
      filter_name: 'Filtres par nom',
      you_can_have: 'Vous pouvez avoir',
      filters_saved: 'filtres sauvegardés.',
      choose_stickers: 'Choisissez les autocollants',
      no_stickers_found: 'Aucun autocollant trouvé',
      basic_filters: 'Filtres de base',
      advanced_filters: 'Filtres avancés',
      clear_all_filters: 'Effacer tous les filtres',
      save_filters: 'Sauvegarder les filtres',
      my_filters: 'Mes filtres',
      filters_are_not_available_on_this_page: 'Les filtres ne sont pas disponibles sur cette page',
    },
    loading_item: 'Chargement de l\'item',
    bestseller: 'Best-seller',
    this_is_your_item: 'Ceci est votre item',
    action: {
      screenshot: 'Capture d\'écran',
      inspect: 'Inspecter en jeu',
      view_at_steam: 'Voir sur Steam',
      check_on_steam_market: 'Voir sur le marché Steam',
      share: 'Partager',
      sell_instantly: 'Vendre instantanément',
      buy: 'Acheter',
      remove_from_sale: 'Retirer de la vente',
      check_on_market: 'Voir sur le marché',
      item_page: 'Page de l\'item',
      bulk_buy: 'Achat groupé',
      add_to_favorites: 'Ajouter aux favoris',
      remove_from_favorites: 'Supprimer des favoris',
      buy_now: 'Acheter maintenant',
      bump: 'Boost',
      sticker: 'Items avec cet autocollant',
    },
    bump_minimum: 'Le boost n\'est possible que pour les items d\'une valeur supérieure à {amount}.',
    your_price: 'Votre prix',
    cart: {
      add_to_cart: 'Ajouter au panier',
      remove_from_cart: 'Retirer du panier',
      add_stickers_to_cart: 'Ajouter des autocollants au panier',
      remove: 'Retirer',
      in_cart: 'Dans le panier',
    },
    details: 'Détails',
    tags: 'Tags',
    do_you_want_rename: 'Voulez-vous renommer votre item ?',
    currently_not_available: 'Actuellement non disponible',
    nametag: 'Étiquette',
    sales: 'Ventes',
    private_offer: 'Offre privée',
    private_offers: 'Offre privée',
    private_offers_description: 'Vous avez {counter} des offres privées. Vous pouvez les trouver',
    public_offer: 'Offre publique',
    offer_visible_only_to_people_with_link: 'Cette offre n\'est visible que par les personnes qui possèdent le lien',
    checkout: {
      if_any: 'Si l\'un des items de votre panier n\'est plus disponible, il ne sera pas ajouté à votre commande.',
      remove_all_items: 'Supprimer tous les items',
      order_summary: 'Récapitulatif de la commande',
      you_will_save: 'Vous économiserez',
      i_have_read: 'J\'ai lu et accepté les conditions de service et la politique de confidentialité et je comprends que tous les achats sont définitifs et non remboursables.',
      confirm_checkout: 'Confirmer le paiement',
      you_need_to_deposit_at_least_x: 'Vous devez déposer au moins {amount} pour acheter les items de votre panier.',
      you_cannot_complete: 'Vous ne pouvez pas terminer votre commande car votre compte n\'est pas suffisamment approvisionné. Vous devez déposer au moins {amount} pour acheter les items de votre panier.',
      these_items_will_be_removed: 'Ces items seront retirés de la liste après le paiement.',
      this_item_will_not_be_included: 'Cet item ne sera pas inclus dans votre commande',
      need_tos_accept: 'Vous devez accepter les conditions d\'utilisation et la politique de confidentialité.',
      no_items_selected: 'Aucun item sélectionné',
    },
    deposit_status: {
      available: 'Disponible',
      missing: 'Disparu',
      not_accepting: 'Ne pas accepter',
      wrong_price: 'Mauvais prix',
      already_queue: 'Déjà dans la file d\'attente',
      locked: 'Bloqué',
    },
    withdraw_progress: {
      status: 'Statut du retrait',
      selected: 'Sélectionné',
      waiting: 'En attente',
      in_queue: 'Dans la file d\'attente',
      trade_link: 'Trade link',
      done: 'Terminé',
      error: 'Erreur',
      failed: 'Échec',
      pending: 'En suspens',
    },
    trade_state: {
      Invalid: 'Invalide',
      Active: 'Actif',
      Accepted: 'Accepté',
      Countered: 'Contré',
      Expired: 'Expiré',
      Canceled: 'Annulé',
      Declined: 'Refusé',
      InvalidItems: 'items non valides',
      CreatedNeedsConfirmation: 'Créé, à confirmer',
      CanceledBySecondFactor: 'Annulé par le deuxième facteur',
      InEscrow: 'En dépôt fiduciaire',
    },
    trade_type: {
      deposit: 'Dépôt',
      withdraw: 'Se retirer',
      bidirectional: 'Bidirectionnel',
    },
    inventory: {
      history: 'Historique',
      active_trades: 'Trades actifs',
      loading_your_inventory: 'Chargement de votre inventaire',
      lower_sale_fee: '{value}% de réduction des frais',
      group_diff_price: 'Tous les items du groupe n\'ont pas le même prix',
      group_diff_delist: 'Tous les items du groupe ne sont pas marqués pour être retirés de la liste.',
      delist: 'Délister',
      this_may_take_a_while: 'Cela peut prendre un certain temps',
      relist_items: 'Relister les items',
      cancel_relisting: 'Annuler la remise en liste',
      cancel_withdrawal: 'Annuler le retrait',
      withdraw_items: 'Retirer des items',
      cancel_editing: 'Annuler la modification',
      edit_items: 'Modifier les items',
      sell_items: 'Vendre des items',
      steam_offers: 'Offres Steam',
      clear_withdraw_items: 'Effacer les items',
      loading_inventory: 'Chargement de l\'inventaire',
      update_x_items: 'Mise à jour de {amount} items',
      delist_x_items: 'Délister {amount} items',
    },
    message: {
      failed_to_create_trade_offer: 'Echec de la création de l\'offre d\'échange',
      offer: 'Offrir {hash}',
      offer_failed: 'L\'offre a échoué (avec le statut {state})',
      offer_confirmed: 'Votre offre a été confirmée et vous avez réussi à mettre en vente vos items.',
      offer_sent: 'Votre offre d\'échange a été envoyée',
      open_trade: 'Ouvrir l\'offre d\'échange',
      withdraw: 'Retrait de l\'offre {hash}',
      withdraw_confirmed: 'Votre retrait a été accepté',
      offer_preparing: 'Votre échange est en cours de préparation. Nous vous enverrons bientôt l\'offre',
      offer_active: 'Votre commerce est prêt. Accepter ici',
      offer_needs_confirmation: 'Confirmer la transaction dans l\'application mobile',
    },
    deposit_type: {
      public: 'Public',
      public_description: 'Vos items seront visibles par tous les utilisateurs de BitSkins. Il s\'agit de l\'option de vente la plus populaire.',
      private: 'Privé',
      private_description: 'Vos items ne seront visibles que par les personnes qui possèdent le lien. La vente privée est 50% moins chère que la vente standard.',
      instant_sell: 'Vente instantanée',
      instant_description: 'Après avoir envoyé les items à notre bot, l\'argent sera immédiatement crédité sur votre compte.',
    },
    click_to_open: 'Cliquez pour ouvrir le lien dans un nouvel onglet',
    no_active_trades: 'Pas de transactions actives',
    go_to_all_trades: 'Voir tous les trades',
    update_trade_link: 'Mise à jour du trade link',
    withdraw: 'Retrait',
    lowest_price: 'Prix le plus bas :',
    no_filters_available: 'Pas de filtres disponibles',
    select_a_hero: 'Sélectionnez un héros :',
    view_all_items: 'Voir tous les items',
    stattrak: 'StatTrak™',
    item_not_available: 'Cet item n\'est plus disponible',
    out_of_stock: 'En rupture de stock',
    find_similar_item: 'Trouver un item similaire',
    find_similar_items: 'Trouver des items similaires',
    sell_for: 'Vendre pour',
    recommended: 'Recommandé',
    price_discounted: 'Prix réduit',
    price_average: 'Prix moyen (recommandé)',
    price_expensive: 'Prix élevé',
    sticker: 'autocollant',
    more: 'Plus',
    recent: 'Recent',
    item_not_found: 'L\'item n\'a pas été trouvé',
    for: 'pour',
    you_will_pay: 'Vous payerez',
    fade: 'Fade : {value}%',
    see_all_items: 'Voir tous les items {amount}',
    it_my_take_a_while: 'Cela peut prendre un certain temps',
    no_transactions_found: 'Aucune transaction trouvée',
    item: 'Item',
    edit: 'Modifier',
    add_items_to_edit: 'Ajouter des items à modifier',
    add_items_to_delist: 'Ajouter des items à retirer de la liste',
    add_items_to_sale: 'Ajouter des items à la vente',
    add_items_to_withdraw: 'Ajouter des items à retirer',
    group_by_name: 'Grouper par nom',
    select_items_from_your_inventory: 'Sélectionnez des item depuis votre inventaire',
    earnings: 'Gains',
    total_fee: 'Frais totaux',
    total_amount: 'Montant total',
    confirm_purchase: 'Confirmer l\'<span class="text-cp">achat</span>',
    thank_you_for_shopping_with_us: '<span class="text-cp">Merci</span> d\'avoir fait vos achats chez nous !',
    you_have_purchased_x_items_for: 'Vous avez acheté <span class="text-cp">{x}</span> items pour',
    you_have_purchased_x_for: 'Vous avez acheté <span class="text-cp">{x}</span> pour',
    total: 'Total',
    you_saved: 'Vous avez économisé',
    see_your_inventory: 'Voir votre inventaire',
    you_bought: 'Vous avez acheté',
    order_details: 'Détails de la commande',
    items_not_available: 'Malheureusement, certains items de votre panier sont devenus indisponibles et vous n\'avez donc pas pu les acheter. Vous trouverez ci-dessous une liste de ces items.',
    total_price: 'Prix total',
    withdraw_all_items: 'Retirer tous les items',
    private_listing: 'Listing privée {extra}',
    public_listing: 'Listing publique {extra}',
    instant_sale_price: 'Prix de vente instantané',
    not_accepted: 'Non accepté',
    not_available: 'Non disponible',
    no_sales_data: 'Pas de données de vente',
    create_buy_order: 'Créer un ordre d\'achat',
    active_buy_orders: 'Vos ordres d\'achat actifs',
    buy_orders_history: 'Historique des ordres d\'achat',
    market_buy_orders: 'Ordres d\'achat sur le marché',
    recent_sales: 'Ventes récentes',
    selling_price: 'Prix de vente',
    sales_chart: 'Graphique de vente',
    sales_history_will_be_available_soon: 'L\'historique des ventes BitSkins et Steam sera bientôt disponible',
    souvenir: 'Souvenir',
    under: '{amount} et en dessous',
    above: '{amount} et au dessus',
    amount_to_amount: 'de {amount1} à {amount2}',
    discount: 'Réduction',
    value_off_or_more: '{value}% ou plus',
    removed_items: 'Item supprimés',
    restore_all_items: 'Restaurer tous les items',
    add_x_items_to_edit: 'Ajouter {amount} items à modifier',
    add_x_items_to_sale: 'Ajouter {amount} items à vendre',
    add_x_items_to_withdraw: 'Ajouter {amount} items à retirer',
    sell_x_items: 'Vendre {amount} items',
    withdraw_x_items: 'Retirer {amount} items',
    first_you_need_to_select_an_item: 'D\'abord vous devez sélectionner un item.',
    cheapest_price_on_bitskins: 'Le prix le plus bas sur BitSkins :',
    final_price: 'Prix final :',
    check_quantity: 'Voir la quantité',
    cancel_selected_orders: 'Annuler les commandes sélectionnées',
    cancel_all_orders: 'Annuler tous les commandes',
    community_rating: 'Évaluation de la communauté :',
    rating: 'Evaluation',
    votes: 'votes',
    open_image: 'Ouvrir l\'image',
    cheaper_than_steam_by_x: '{x}% Moins cher que Steam',
    there_are_other_items_you_may_like: '<span>Il y a d\'autres items</span> que vous pourriez aimer...',
    available_variants: 'Variantes disponibles',
    picture: {
      playside: 'Playside',
      backside: 'Backside',
      steam: 'Image du marché Steam',
    },
    buy_orders_not_available: 'Les ordres d\'achat ne sont actuellement pas disponibles',
    confirm_price_change: 'Confirmer le changement de prix',
    are_you_sure_to_change_price: 'Êtes-vous sûr de vouloir changer le prix pour <span class="text-cp fw-sb">{price}</span>?',
  },
  bumps: {
    heading: 'Vous souhaitez <span class="text-cp">vendre vos items plus rapidement</span> sans réduire leur prix ?',
    subheading: 'Nous avons quelque chose pour vous !',
    how_it_works: '<span class="text-cp">Comment</span> ça marche ?',
    description: 'Chez BitSkins, nous disposons d\'une option de boost qui vous permet de présenter vos items sur la page du marché et à d\'autres endroits du site Web. C\'est une solution parfaite pour ceux qui souhaitent accélérer le processus de vente de leurs items sans avoir à en baisser le prix. Lorsque vous mettez un item en avant, davantage de personnes le voient et les chances de le vendre augmentent. Vous pouvez commencer à surenchérir sur vos items à partir de 0,75$ ou même moins (veuillez consulter nos forfaits de pack de boosts).',
    your_active_x_autobumps: 'Votre {x} auto boosts',
    bumps_packages: 'Boosts pack',
    bumps: 'boosts',
    bumps_title: 'Boosts',
    available_bumps: 'Boosts disponibles',
    buy_selected_package: 'Acheter le pack sélectionné',
    when_you_bump: 'Lorsque vous boostez un item, il est affiché aux endroits suivants :',
    step_1_title: 'Sur la page du marché, <span class="text-cp">dans la barre du haut</span>',
    step_2_title: 'Sur la page du marché dans la <span class="text-cp">section principale</span>',
    step_2_text: '(Uniquement si l\'option de tri est définie sur "en vedette". Il s\'agit de l\'option par défaut).',
    step_3_title: 'Sur la <span class="text-cp">page d\'accueil</span>',
    step_4_title: 'Sur la page de l\'item dans la section <span class="text-cp">items similaires</span> ',
    step_5_title: 'Dans la section des <span class="text-cp">items suggérés</span> ',
    after_bumping: '<span class="text-cp">Lorsqu\'un item est boosté</span>, il apparaît <span class="text-cp">en première position</span> dans chaque section. Cependant, <span class="text-cp">si quelqu\'un d\'autre boost son item après vous</span>, votre item sera déplacé à la <span class="text-cp">deuxième place</span>. Votre item sera visible dans chaque section tant qu\'il n\'y aura pas suffisamment de boosts pour le faire sortir de la section.',
    how_to_bump: '<span class="text-cp">Comment</span> booster mon item ?',
    how_to_1: 'Ouvrir le menu de l\'items',
    how_to_2: 'Sélectionner l\'option <span class="text-cp">"boost"</span>',
    how_to_3: 'Choisir le type de boost',
    how_to_4: 'C\'est fait !',
    table: {
      item: 'Item',
      quantity: 'Quantité',
      left: 'Restant',
      period: 'Période',
      created_at: 'Créé le',
      updated_at: 'Mise à jour le',
      next_bump_at: 'Prochain boost à',
      action: 'Action',
      status: 'Statut',
    },
    auto_enabled: 'Auto boost activé',
    auto_disabled: 'Auto boost annulé',
    single_bumped: 'L\'item a bien été boosté !',
  },
  buy_order: {
    confirm_buy_orders_cancellation: 'Confirmer <span class="color-primary">l\'annulation des ordres d\'achat</span>',
    are_you_sure_that_you_want_to_cancel: 'Êtes-vous sûr de vouloir annuler tous vos ordres d\'achat ?',
    create_buy_order: 'Créer<span class="text-cp">un ordre d\'achat</span>',
    predict_place_in_queue: 'Prévoir la place dans la file d\'attente',
    your_place_in_the_queue: 'Votre place dans la file d\'attente :',
    may_purchase_items_with_trade_hold: 'Les ordres d\'achat peuvent permettre d\'acheter des items avec un trade hold.',
    create_a_buy_order_for_this_item: 'Créer un ordre d\'achat pour cet item',
    no_buy_orders_found: 'Aucun ordre d\'achat trouvé',
    position_in_queue: 'Position dans la file d\'attente',
    this_is_your_buy_order: '(il s\'agit de votre ordre d\'achat)',
    skin_name: 'Nom du skin :',
    offers_on_market: 'offres sur le marché',
  },
  instant_sell: {
    confirmation: 'Confirmer la vente instantanée',
    you_can_sell_x: 'Vous pouvez vendre votre AWP | Asiimov (Testée sur le terrain) instantanément et recevoir $10.',
    the_funds_will_be_credited: 'Les fonds seront immédiatement crédités sur votre compte. Si vous souhaitez continuer, cliquez sur "Vendre instantanément".',
  },
  sort: {
    select_option: 'Sélectionner une option',
    apply: 'Appliquer',
    clear: 'Vider',
    default_order_placeholder: 'Sélectionner une option',
    select_order_placeholder: 'Sélectionner le filtre',
    default_sort: 'Tri par défaut',
    custom_sort: 'Filtre personnalisé',
    field: {
      price: 'Prix',
      discount: 'Réduction',
      id: 'Date d\'ajout',
      bumped_at: 'A la une',
      suggested_price: 'Prix conseillé',
      asset_id: 'Date d\'ajout',
      float_value: 'Float',
      paint_index: 'Paint index',
      paint_seed: 'Paint seed',
      extras_1: 'Valeur supplémentaire',
      extras_1_fade: 'Fade',
      amount: 'Montant',
      name: 'Nom',
    },
    order: {
      price: {
        asc: 'Le moins cher d\'abord',
        desc: 'Le plus cher d\'abord',
      },
      discount: {
        desc: 'Le plus haut d\'abord',
      },
      id: {
        asc: 'Le plus ancien d\'abord',
        desc: 'Le plus récent d\'abord',
      },
      asset_id: {
        asc: 'Le plus ancien d\'abord',
        desc: 'Le plus récent d\'abord',
      },
      bumped_at: {
        desc: 'Défaut',
        asc: '',
      },
      default: {
        asc: 'Le plus bas d\'abord',
        desc: 'Le plus haut d\'abord',
      },
    },
  },
  pagination: {
    showing: 'affiche de',
    to: 'à',
    of: 'sur',
    records: 'items enregistrés',
  },
  popups: {
    click_confirmation_link: 'Veuillez consulter votre e-mail et cliquer sur le lien de confirmation pour terminer le processus.',
    steam_login_issue: {
      title: 'Problème de connexion à Steam',
      an_error_occured: 'Une erreur s\'est produite lors de la tentative de connexion via Steam. Veuillez réessayer.',
    },
    steam_inventory_private: {
      title: 'Votre inventaire Steam est <span class="text-cp">privé</span>',
      we_were: 'Nous n\'avons pas pu charger votre inventaire Steam. Veuillez passer votre inventaire en mode public.',
      you_can: 'Vous pouvez effectuer cette action dans les paramètres de Steam. Veuillez noter qu\'il peut s\'écouler quelques minutes avant que les modifications ne soient prises en compte.',
      steam_settings: 'Paramètres Steam',
    },
    account_deletion_in_progress: {
      title: 'Suppression du compte en cours...',
      process_started: 'Vous avez entamé la procédure de suppression du compte.',
      account_will_be_deleted: 'Votre compte sera supprimé le',
      cancel_deletion: 'Annuler la suppression',
      confirm_deletion: 'Confirmer la suppression',
      check_your_email: 'Consultez votre e-mail',
    },
    account_deletion_confirm: {
      title: 'Confirmer la suppression du compte',
      subtitle: 'Êtes-vous sûr de vouloir supprimer votre compte ?',
      once_you_confirm: 'Une fois votre confirmation effectuée, vous serez automatiquement déconnecté, et toutes les données de votre compte seront définitivement supprimées après deux semaines. Pendant cette période, vous pourrez annuler le processus de suppression en vous connectant à votre compte.',
      once_your_account_is: 'Après la suppression de votre compte, vous pourrez créer un nouveau compte BitSkins en vous connectant sur le site web.',
      however_you_will_not: 'Cependant, vous n\'aurez pas accès aux données supprimées.',
      if_you_want_to_continue: 'Si vous voulez continuer, cliquez sur confirmer et cliquez sur le lien de confirmation dans l\'e-mail que nous vous avons envoyé.',
      login: 'Vous devez vous connecter pour confirmer la suppression du compte',
      canceled: 'La suppression du compte a été annulée',
      confirmed: 'Suppression du compte confirmée',
    },
    account_deletion_check_your_email: {
      title: 'Vérifiez votre e-mail',
      to_complete: 'Pour terminer la procédure de suppression du compte, cliquez sur le lien de confirmation figurant dans l\'e-mail que nous vous avons envoyé.',
    },
    twofa_enable: {
      already_done: 'Vous avez déjà activé A2F.',
      setup_email_before: 'Pour activer la fonction A2F, vous devez d\'abord configurer l\'e-mail.',
      twofa_authentication_adds: 'L\'authentification à deux facteurs (A2F) ajoute une couche supplémentaire de sécurité à votre compte en exigeant deux méthodes (facteurs) pour vérifier votre identité. Il est fortement recommandé d\'activer l\'authentification à deux facteurs pour assurer la sécurité de votre compte, car elle empêche les connexions indésirables.',
      setup_twofa: 'Configurer l\'authentification à deux facteurs',
      if_you_dont_have_an_authenticator_app: 'Si vous <span class="text-cp">n\'avez pas</span> d\'application d\'authentification',
      we_recommend: '<p>Nous recommandons <a href="https://support.google.com/accounts/answer/1066447?hl=en" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Google Authenticator</a> ou <a href="https://authy.com/download/" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Authy</a> pour les utilisateurs d\'Android et d\'iOS. Si vous souhaitez utiliser l\'application sur votre ordinateur, vous pouvez télécharger et installer <a href="https://authy.com/download/" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Authy</a> ou utiliser l\'<a href="https://chrome.google.com/webstore/detail/authenticator/bhghoamapcdpbohphigoooaddinpkbai" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">extension Google Authenticator</a> dans votre navigateur.',
      scan_the_qr_code: '<span class="text-cp">Scanner</span> le code QR',
      open_your_authenticator_app: 'Ouvrez votre application d\'authentification et scannez le code QR ou saisissez la clé secrète manuellement.',
      secret_key: 'Clé secrète',
      this_secret_key_will_be_valid_for_x_seconds: 'Cette clé secrète sera valable pendant <span class="text-cp">{x} @:{\'time.seconds\'}</span>.',
      save_this_secret: 'Conservez cette clé secrète dans un endroit sûr. Elle vous permettra de retrouver l\'accès à vos codes A2F<br> si vous perdez l\'accès à l\'application d\'authentification.',
      enter_the_6_digit_code: 'Saisissez le <span class="text-cp">code à 6 chiffres</span> généré par votre application d\'authentification.',
      enter_code_from_the_email: 'Saisir le code figurant dans l\'<span class="text-cp">e-mail</span>',
      enter_the_verification_code: 'Saisissez le code de vérification que nous avons envoyé à <span class="text-cp">{email}</span>.',
      desktop: 'Bureau',
    },
    twofa_enabled: {
      now_your_account_is: 'Votre compte est désormais protégé par une authentification à deux facteurs.',
      all_future_logins: 'Toutes les connexions futures nécessiteront désormais la saisie d\'un code fourni par votre application d\'authentification.',
    },
    twofa_enter_code: 'Saisissez le code A2F généré par votre application d\'authentification.',
    twofa_disable: {
      title: 'Désactiver l\'authentification à deux facteurs',
      enter_the_6_digit_code: 'Saisissez le code à 6 chiffres généré par votre application d\'authentification.',
      cannot_access: 'Vous n\'arrivez pas à accéder à votre code de vérification ? Veuillez nous contacter à l\'adresse suivante',
    },
    twofa_disabled: 'Votre compte n\'est plus protégé par l\'authentification à deux facteurs.',
    order_unable_to_process: {
      title: 'Nous n\'avons pas pu <span class="text-cr">traiter votre commande</span>',
      an_error_occurred: 'Une erreur s\'est produite lors du traitement de votre commande.<br> Veuillez retourner à la page de paiement et réessayer de passer la commande.',
      back_to_checkout: 'Retour au panier',
      back_to_item: 'Retour à l\'item',
      information: 'Si cette erreur se produit souvent, vous devez nous contacter par l\'intermédiaire de la <a rel="nofollow noopener noreferrer" target="_blank" href="https://bitskins.com/support" class="text-cp">page de support</a> en indiquant le code d\'erreur :',
    },
    phone_number_add: {
      title: 'Ajouter votre numéro de téléphone',
      to_continue: 'Pour continuer, vous devez d\'abord ajouter votre numéro de téléphone à votre compte.',
      add_number: 'Ajouter un numéro',
    },
    phone_number_confirmed: {
      title: 'Numéro de téléphone confirmé',
      your_phone_number: 'Votre numéro de téléphone a été confirmé.',
    },
    phone_number_verify: {
      title: 'Vérifiez votre numéro de téléphone',
      to_verify: 'Pour vérifier votre numéro de téléphone, vous devez saisir le code de vérification que nous vous avons envoyé.',
      enter_sms_code: 'Saisir le code SMS',
      you_cannot_update: 'Vous ne pouvez pas mettre à jour votre numéro de téléphone à ce stade. Vous pourrez le faire dans {minutes} minutes.',
    },
    phone_number_verification_in_progress: {
      title: 'Vérification du numéro de téléphone en cours',
      if_you_wish: 'Si vous le souhaitez, vous pouvez mettre à jour votre numéro de téléphone ou renvoyer le code de vérification.',
      send_code: 'Envoyer le code',
    },
    email_address_add: {
      your_email_address: 'votre adresse e-mail',
      by_providing_my_email: 'En fournissant mon adresse e-mail, j\'accepte de recevoir des communications marketing.',
      verification_in_progress: 'Vérification de l\'e-mail en cours',
      to_verify: 'Pour vérifier votre adresse e-mail, vous devez cliquer sur le lien de confirmation figurant dans l\'e-mail que nous vous avons envoyé.',
      if_you_wish: 'Si vous le souhaitez, vous pouvez mettre à jour votre adresse e-mail ou renvoyer le lien d\'activation.',
    },
    email_address_verify: {
      we_are_verifying: 'Nous sommes en train de vérifier votre adresse e-mail et cela peut prendre un certain temps...',
      confirmed: 'Votre adresse e-mail a été confirmée.',
    },
    email_address_confirmed: {
      title: 'Adresse e-mail confirmée',
      your_email_address: 'Votre adresse e-mail a été confirmée.',
    },
    enter_your_trade_url: {
      title: 'Entrer votre <span class="text-cp">trade URL</span>',
      to_continue: 'Pour continuer, vous devez d\'abord configurer votre trade URL. Vous la trouverez',
      your_trade_url: 'Votre trade link',
    },
    password_reset_enter_email: {
      forgot: 'Vous avez oublié votre',
      password: 'mot de passe ?',
      dont_worry: 'Ne vous inquiétez pas, entrez votre adresse e-mail ci-dessous.',
      we_will_send: 'Nous vous enverrons un lien pour réinitialiser votre mot de passe.',
      send_reset_link: 'Envoyer le lien de réinitialisation',
      if_this_email: 'Si cet e-mail est associé à un compte BitSkins,',
      you_will_receive: 'vous recevrez un e-mail contenant un lien pour réinitialiser votre mot de passe.',
    },
    password_reset_new_password: {
      enter_your: 'Saisissez votre',
      new_password: 'nouveau mot de passe',
      enter_password: 'Entrer le mot de passe',
      repeat_password: 'Répéter le mot de passe',
      save_password: 'Sauvegarder le mot de passe',
    },
    link_expired: {
      title: 'Lien expiré',
      the_process_cannot: 'Ce processus n\'a pas pu être achevé. Le lien a déjà expiré.',
      go_to_settings: 'Accéder aux paramètres',
    },
    wrong_link: {
      title: 'Lien incorrect',
      we_were_unable: 'Nous n\'avons pas pu traiter votre demande. Vous avez suivi un lien incorrect.',
    },
    trade_preparing: {
      title: 'Nous préparons votre offre d\'échange',
      processing: 'Cela peut prendre quelques secondes...',
    },
    trade_sent: {
      trade_offer_has_been_sent: 'Votre offre d\'échange a <span class="text-cp">été envoyé</span>',
    },
    trade_done: {
      title: 'L\'offre d\'échange a bien été <span class="text-cp">acceptée</span>',
      listed: 'Vous avez réussi à mettre en vente vos items. Vous pouvez les gérer dans l\'<a rel="nofollow noopener noreferrer" href="https://bitskins.com/selling" class="text-cp">onglet vente</a>.',
      see_listed: 'Voir vos items listés',
      withdrawn: 'Vous avez retiré vos items avec succès.',
    },
    trade_declined: {
      your_trade_offer_has_been: 'Votre offre d\'échange a été',
      declined: 'décliné',
      if_you: 'Si vous ne l\'avez pas refusé vous-même, cela signifie que quelqu\'un utilise votre compte et que vos items risquent d\'être volés.',
      to_stay: 'Pour protéger vos items, agissez rapidement et suivez les étapes suivantes :',
      step_revoke: 'Révoquez votre clé Steam Web API.',
      step_revoke_btn: 'REVOQUEZ LA CLÉ API',
      step_password: 'Modifiez votre mot de passe Steam.',
      step_password_btn: 'MODIFIER LE MOT DE PASSE',
      step_deauth: 'Supprimer l\'autorisation des appareils sur Steam',
      step_deauth_btn: 'SUPPRIMER L\'AUTORISATION DES APPAREILS',
      step_trade: 'Créez un nouveau trade URL Steam.',
      step_trade_btn: 'CRÉER UN NOUVEAU TRADE URL',
      step_new: 'Définissez votre nouveau trade link sur BitSkins.',
      step_new_btn: 'DÉFINIR UN NOUVEAU TRADE URL',
      step_try: 'Essayez de déposer à nouveau vos items et voyez si le problème persiste.',
      step_try_if: 'Si le problème persiste, arrêtez toutes les transactions et contactez notre support.',
      contact_support: 'Contacter le support',
      information: 'Gardez à l\'esprit que les membres de notre équipe et les bots ne demanderont jamais de dépôt via Steam Chat, Discord ou ailleurs - toute personne prétendant être un administrateur, etc. est fausse et cherche probablement à vous arnaquer. Restez en sécurité !',
    },
    trade_failed: {
      offer_failed_title: 'L\'offre d\'échange a <span class="text-cr">échoué</span>',
      offer_failed_text: 'Malheureusement, votre offre d\'échange n\'a pas abouti. Veuillez réessayer.',
      offer_failed_to_create_title: '<span class="text-cr">Échec</span> de la création de l\'offre d\'échange',
      offer_failed_to_create_text: 'Malheureusement, nous n\'avons pas pu créer votre offre d\'échange. Veuillez réessayer.',
      contact_support: 'Si cette erreur se produit souvent, vous devez nous contacter via <a rel="nofollow noopener noreferrer" target="_blank" href="https://bitskins.com/support" class="text-cp">la page de support</a>.',
      support_page: 'page de support',
      cannot_process: 'Nous ne pouvons pas traiter votre offre d\'échange',
      unfortunately_we_were_unable: 'Malheureusement, nous n\'avons pas pu traiter votre offre d\'échange. Il est très probable que vous ayez déjà une offre d\'échange active pour ces items.',
    },
    items_not_available: {
      title: 'Les items ne sont plus disponibles à la vente',
      unfortunately: 'Malheureusement, les items de votre panier <span class="text-cy-secondary">ne sont plus disponibles à la vente</span>.',
      dont_worry: 'Ne vous inquiétez pas, vous trouverez de nombreux items sur la page du marché.',
      unavailable_items: 'items non disponibles',
      back_to_market: 'Retour au marché',
    },
    bump_purchase_confirmation: {
      title: 'Confirmation d\'achat',
      do_you_want_to_purchase: 'Souhaitez-vous acheter <span class="text-cp">{quantity} de boosts</span> pour <span class="text-cp">{price}</span>?',
      bumps_package: 'boosts pack',
    },
    bump_start: {
      title: 'Boost votre item',
      bump_your_item: 'Boostez votre item pour le mettre en avant sur la page du marché et sur d\'autres emplacements du site.<br> Cela peut accélérer sa vente en lui assurant une meilleure visibilité auprès d\'un plus large public.<br> Si vous souhaitez en savoir plus sur le fonctionnement de la fonction de boost',
      click_here: 'click ici',
      single_bump: 'Boost unique',
      autobumps: 'Auto boosts',
      one_bump: '1 boost',
      this_option_single_bump: 'Cette option permet d\'effectuer un seul boost sur votre item et coûte <span class="text-cp">0,75$</span>. Si vous avez déjà des boosts disponibles sur votre compte, rien ne sera débité de votre solde.',
      this_option_autobumps: 'Cette option permet de boost votre item à chaque période de temps sélectionnée. Si vous avez déjà des boosts disponibles sur votre compte, rien ne sera débité de votre solde. Si vous n\'en avez plus, <span class="text-cp">0,75$</span> seront déduits de votre solde à chaque boost. <span class="text-cp">Vous pouvez acheter plus de boosts à l\'avance</span> et en même temps <span class="text-cp">économiser de l\'argent</span> - défilez vers le bas pour consulter les forfaits de pack de boosts.',
      bump_every: 'Boost tous les',
      bumps_amount: 'Quantité de boosts',
      delayed_start: 'Départ retardé',
      delayed_start_description: 'En cochant cette option, votre premier boost sera retardé de la période sélectionnée.',
    },
    bump_stop: {
      title: 'Arrêter l\'auto boosts',
      do_you_want: 'Voulez-vous arrêter les auto boosts pour cet item ?',
    },
    bulk_buy: {
      bulk_buy: '<span class="text-cp">Achat </span>groupé',
      maximum_items_you_can_buy: 'Nombre maximum d\'items que vous pouvez acheter pour ce prix :',
      may_purchase_items_with_trade_hold: 'La fonctionnalité d\'achat groupé peut acheter des items avec un trade hold.',
    },
  },
  affiliate: {
    ad_info: 'Si vous ne voyez pas la boîte, veuillez essayer de désactiver votre bloqueur de publicités.',
    affiliate_code: 'Code d\'affiliation',
    affiliate_link: 'Lien d\'affiliation',
    level: 'Niveau',
    levels: 'Niveaux d\'<span class="text-cp">affiliation</span>',
    our_levels: 'Nos niveaux',
    your_code: 'Votre code d\'<span class="text-cp">affiliation</span>',
    your_affiliate_statistics: 'Vos statistiques d\'<span class="text-cp">affiliation</span>',
    earn_money_by_simply_sharing: '<span class="text-cp">Gagnez de l\'argent</span> en partageant simplement votre amour pour BitSkins avec votre audience !',
    percent_from_sale_fee: '{value}% de frais de vente',
    join_the_bitskins_affiliate: 'Rejoignez le programme d\'affiliation BitSkins et gagnez des commissions sur chaque vente réalisée via votre lien d\'affiliation unique. Que vous ayez un large public ou seulement quelques amis proches, plus vous partagez, plus vous gagnez.',
    tile_1_title: 'Partagez BitSkins avec votre audience',
    tile_1_description: 'Créez votre propre lien d\'affiliation en quelques secondes et commencez à le partager avec vos amis ou votre audience.',
    tile_2_title: 'Observez vos profits augmenter',
    tile_3_title: 'Réclamez votre gain',
    tile_3_description: 'Les fonds obtenus grâce au programme d\'affiliation peuvent être dépensés pour l\'achat d\'items ou peuvent être retirés de BitSkins. C\'est vous qui décidez !',
    kyc_you_cannot_use: 'Vous ne pouvez pas utiliser le système d\'affiliation car vous n\'avez pas suivi la procédure KYC. Vous pouvez commencer le processus de vérification dès maintenant.',
    your_percentage: 'Votre pourcentage',
    generated: 'Généré',
    individual_affiliate_program: 'Programme d\'affiliation individuel',
    if_you_or_your_business: 'Si vous ou votre entreprise êtes impliqué dans l\'esports ou si vous avez une grande influence sur les médias sociaux, veuillez nous contacter via </span>partnership{\'@\'}bitskins.com</span>. Nous sommes en mesure de vous proposer des conditions d\'affiliation individuelles.',
    invited_referrals: 'Filleuls invités',
    active_referrals: 'Filleuls actifs',
    your_percentage_sales_fee: 'Votre pourcentage de frais de vente',
    your_total_earnings: 'Vos gains totaux',
    available_earnings: 'Gains disponibles',
    you_can_claim_your_earnings_one_a_day: 'Vous pouvez réclamer vos gains une fois par jour. Une fois réclamés, ils apparaîtront dans votre solde retirable sous 24 heures. Le montant minimum pour effectuer un retrait est de',
    to_reach_the_next_level: 'Pour atteindre le niveau suivant et toucher des commissions plus élevées, vous devez générer <span class="text-cp">{x}</span> de ventes grâce à vos filleuls.',
    any_user_that_registers_from_your_affiliate_link: 'Tout utilisateur qui s\'inscrit à partir de votre lien d\'affiliation sera automatiquement désigné comme votre filleul.',
    my_earnings: '<span class="text-cgs">Mes</span> gains',
    referred_users: 'Utilisateur<span class="text-purple">affilié</span> ',
    code_updated: 'Code d\'affiliation mis à jour avec succès',
    not_enough_money: 'Pas assez d\'argent pour le transfert',
    account: 'Compte',
    referrals_sales: 'Historique des ventes de vos filleuls',
  },
  profile: {
    hi: 'Salut',
    nav: {
      account: 'Compte',
      wallet: 'Portefeuille',
      transactions: 'Transactions',
      statistics: 'Statistiques',
      affiliate: 'Affiliation',
      company: 'Entreprise',
      trades: 'Trades',
      items_history: 'Historique des items',
    },
    top_star: {
      you_are: 'Vous êtes',
      top_star: 'TOP STAR',
      good_to_see_you: 'Hey "{username}", c\'est un plaisir de vous voir sur BitSkins !',
      appreciate_using: 'Nous apprécions que vous ayez décidé d\'utiliser notre plateforme,',
      extra_settings: 'C\'est pourquoi nous avons préparé quelques paramètres supplémentaires pour vous.',
      show_nickname_selling: 'Afficher mon pseudo sur la page de l\'item lors de la vente',
      show_nickname_store: 'Mettre en évidence mon pseudo sur la page du magasin',
    },
    basic: {
      basic_information: 'Informations de base',
      username: 'Nom d\'utilisateur',
      change_username: 'Modifier le nom d\'utilisateur',
      registration_date: 'Date d\'inscription',
      email: 'E-mail',
      change_email: 'Modifier l\'e-mail',
      password: 'Mot de passe',
      change_password: 'Modifier le mot de passe',
      phone: 'Numéro de téléphone',
      change_phone: 'Modifier de numéro de téléphone',
      hide_balance: 'Cachez votre solde',
      hide_balance_description: 'Le montant des fonds sera caché dans l\'en-tête, mais il restera visible après avoir appuyé sur le portefeuille.',
    },
    security: {
      you_can_access_your_account: 'Vous pouvez accéder à votre compte à l\'aide d\'une clé API. Notre documentation sur l\'API se trouve à l\'adresse suivante',
      api_status: 'Statut de l\'API',
      security: 'Sécurité',
      twofa: 'Authentification à deux facteurs',
      temporarily_block_my_account: 'Bloquer temporairement mon compte',
      temporarily_block_title: '<span class="text-cr">Bloquer mon compte</span> temporairement',
      temporarily_block_description: 'Si vous pensez que votre compte a été compromis, vous pouvez le bloquer temporairement.\nNous débloquerons votre compte après avoir contacté notre support.',
      temp_blocked: 'Votre compte a été temporairement bloqué.\nVeuillez contacter notre support pour clarifier la situation.',
      block_my_account: 'Bloquer mon compte',
      delete_account: 'Supprimer le compte',
      delete_my_account: 'Supprimer mon compte',
      sessions: 'Sessions',
      close_all_sessions: 'Fermer toutes les sessions',
      current_session: 'Session en cours',
      active_sessions: 'Sessions actives',
      no_other_sessions: 'Pas d\'autres sessions',
      removed: 'Supprimé',
      online: 'En ligne',
      api_key: 'Clé API',
      api_key_not_available: 'La clé API n\'est visible qu\'une seule fois lors de sa création',
      sensitive_hidden: 'Informations sensibles cachées',
      ip_whitelist: 'IP whitelist',
      add_ip_to_whitelist: 'Ajouter une IP à la whitelist',
      disable_api_confirm: 'Confirmer la désactivation de l\'accès à l\'API',
      disable_api_content: 'Êtes-vous sûr de vouloir désactiver l\'accès API pour votre compte ?',
    },
    store: {
      my_store: 'Mon magasin',
      store: 'magasin',
      store_url: 'Magasin url',
      store_alias: 'Alias du magasin',
      id_store: 'ID MAGASIN',
      hide_store: 'Masquer la page de votre magasin',
      url_copied: 'Copie de l\'url du magasin',
      total_items: 'Total des items :',
      games: 'Jeux :',
    },
    setting: {
      account_email: 'E-mail du compte',
      update_email: 'Mise à jour de l\'e-mail',
      setup_email: 'Configuration de l\'e-mail',
      update_password: '<span class="text-cp">Mettre à jour</span> le mot de passe',
      set_password: '<span class="text-cp">Définir</span> le mot de passe',
      enter_current_password: 'Saisir le mot de passe actuel',
      password_changed: 'Mot de passe modifié',
      current_password: 'Mot de passe actuel',
      enter_new_password: 'Saisir le nouveau mot de passe',
      repeat_new_password: 'Répéter le nouveau mot de passe',
      save_new_password: 'Enregistrer le nouveau mot de passe',
      new_password: 'Nouveau mot de passe',
      repeat_password: 'Répéter le mot de passe',
      account_2fa: 'Compte A2F',
      enable_2fa: 'Activer A2F',
      disable_2fa: 'Désactiver A2F',
    },
    transaction: {
      amount: 'Montant',
      type: 'Type',
      details: 'Détails',
      fee: 'Frais',
      buyer_country: 'Pays de l\'acheteur',
      seller_country: 'Pays du vendeur',
      price: 'Prix',
      item_name: 'Nom de l\'item',
      transaction_history: 'Historique des transactions',
      operation: 'Opération',
      trade_id: 'Trade ID',
      loading_trade_offers: 'Chargement des offres d\'échange',
      no_trades_found: 'Aucune offre d\'échange trouvée',
      id: 'ID',
      date: 'Date',
      game: 'Jeu',
      items: 'Items',
      status: 'Statut',
      time_left: 'Temps restant',
      action: 'Action',
      trades_active: 'Trades actifs',
      trades_history: 'Historique des trades',
      balance: 'Solde',
      history: 'Historique des transactions',
      pending: 'Transactions en attente',
      reports: 'Rapports exportés',
      active_locks: 'Verrous actifs',
      export: 'Exporter',
      export_to_csv: 'Exporter au format .CSV',
      export_description: 'Sélectionnez le mois et l\'année pour lesquels vous souhaitez générer le rapport.',
      the_report_will_appear_in_the: 'Le rapport apparaîtra dans...',
      tab_once_the_export_process_is_complete: 'une fois le processus d\'exportation terminé.',
    },
  },
  fee: {
    individual: 'Individuel',
    individual_fee: 'Frais individuel',
    custom_sale_fee: 'Votre frais de vente personnalisé',
    your_current_fees: 'Vos frais actuels',
    high_tier: 'High tier',
    fee: 'Frais',
    fee_up_to: 'frais',
    sale_fee: 'Frais de vente',
    sales_fees: 'Frais de vente',
    see_all_levels: 'Voir tous les niveaux',
    you_are_on_the: 'Vous êtes sur le',
    maximum_sales_fee: 'Frais de vente maximum : {value}',
    your_total_sale_volume: 'Le montant total de vos ventes jusqu\'à présent est de',
    sales_fees_will_be_lowered: 'Les frais de vente diminueront à mesure que vous vendrez des items.',
    level: 'niveau',
    your_level: 'Votre niveau :',
    progress: 'Progrès :',
    max_level: 'Niveau maximum',
    next_level: 'Niveau suivant :',
    total_income: 'Revenu total',
    total_revenue: 'Recettes totales',
    sold_items: 'Item vendu',
    page: {
      sales_fees_depends_on_two_factors: 'Sur BitSkins, les <span class="text-cp">FRAIS DE VENTE</span> dépendent de deux facteurs :',
      the_price: '1. Le prix auquel vous vendez votre item',
      the_listing_type: '2. Le type de listing : ',
      listing_type_public: 'Public - votre item est visible par tous les utilisateurs du site.',
      listing_type_private: 'Privé - votre item n\'est visible que par les personnes avec lesquelles vous partagez le lien.',
      fee_explanation: 'Plus le prix de vente de votre item est élevé, plus la commission de vente est faible. Les frais de vente standard vont de 2,5% (pour les annonces privées) à un maximum de 10% (pour les annonces publiques). En outre, nous avons 5 niveaux de vente différents qui vous permettent de réduire encore plus vos frais de vente. La règle est simple : plus vous vendez, moins vous payez de frais de vente. Vous pouvez réduire vos frais de vente jusqu\'à 2,4% (pour les annonces privées) ou jusqu\'à 9,8% (pour les annonces publiques). Notre système de frais est transparent et il n\'y a pas de frais cachés.',
      default_sales_fees_title: 'Frais de vente par <span class="text-cp">défaut</span>',
      default_sale_fees_description: 'Si vous débutez et que vous n\'avez pas encore vendu d\'items, les frais de vente seront les suivants :',
      how_to_reduce_my_sales_fees_title: '<span class="text-cp">Comment réduire</span> mes frais de vente ?',
      how_to_reduce_my_sales_fees_description: 'BitSkins propose 5 niveaux de vente. Chacun d\'entre eux (à l\'exception du niveau 1) réduit vos frais de vente de 0,05%. Pour passer à un niveau supérieur, vous devez vendre des items dans une certaine tranche de prix.',
      sales_fees_levels: '<span class="text-cp">Niveaux de frais</span> de vente',
      price_range: 'Fourchette de prix',
      total_sales: 'Ventes totales',
      fee_reduced_by: 'Frais réduits de',
      individual_sales_fees_title: 'Frais de vente individuels',
      individual_sales_fees_description: 'Si vous utilisez activement bitkins et que votre chiffre d\'affaires mensuel est d\'au moins <span class="span text-csfl6">{amount}</span>, n\'hésitez pas à nous contacter. Nous pouvons vous proposer  <span class="text-csfl6">des frais de vente encore plus faible</span> et une <strong>assistance supplémentaire</strong>.',
    },
  },
  copy: {
    text_copied: 'Texte copié',
    cannot_copy: 'Impossible de copier',
    name_copied: 'Nom copié',
    cannot_copy_name: 'Impossible de copier le nom',
    copy_link: 'Copier le lien',
  },
  share: {
    share_on_twitter: 'Partager sur Twitter',
    share_on_facebook: 'Partager sur Facebook',
    share_on_telegram: 'Partager sur Telegram',
  },
  discord: {
    discord: 'Discord',
    already_connected: 'Déjà connecté',
    something_went_wrong: 'Quelque chose n\'a pas fonctionné',
    success: 'Succès !',
    loading: 'Chargement...',
    connect_with_discord: 'Se connecter avec Discord',
  },
  telegram: {
    already_connected: 'Déjà connecté',
    something_went_wrong: 'Quelque chose n\'a pas fonctionné',
    success: 'Succès !',
    loading: 'Chargement...',
  },
  error: {
    error_404: 'Erreur 404',
    page_not_found: 'Page non trouvée',
  },
  kyc: {
    description_1: 'Afin de garantir la sécurité des transactions effectuées sur notre site et de nous conformer aux réglementations AML/KYC en vigueur, nous vous demandons de vous soumettre à un processus de vérification des données (KYC). Il existe trois niveaux de vérification. Chacun de ces niveaux augmente ou supprime complètement les limites et vous donne accès à de nouvelles méthodes de paiement.',
    description_2_start: 'Les conditions détaillées concernant le processus de vérification KYC sont décrites dans nos conditions de service. Nous tenons à vous assurer que toutes les données que vous nous fournissez seront utilisées conformément à la loi sur la protection des données.',
    description_2_end: 'En lançant le processus de vérification KYC, vous acceptez que nous traitons vos données à des fins légalement justifiées.',
    personal_data: 'Données personnelles',
    first_name: 'Prénom',
    middle_name: 'Deuxième prénom',
    last_name: 'Nom de famille',
    street_name: 'Nom de la rue',
    street_number: 'Numéro de rue',
    postal_code: 'Code postal',
    city: 'Ville',
    province: 'Province',
    country: 'Pays',
    start_kyc_verification: 'Commencer la vérification KYC',
    upload: 'Télécharger',
    uploaded: 'Téléchargé',
    image_uploaded: 'Image uploadée',
    document_type: {
      id: 'ID',
      driving_license: 'Permis de conduire',
      passport: 'Passeport',
      other: 'Autre',
    },
    limit: {
      crypto_withdraw: 'Limite annuelle des retraits de crypto-monnaie de {amount}',
      crypto_withdraw_unlimited: 'Retraits illimités de crypto-monnaie',
      non_crypto_withdraw: 'Limite annuelle des retraits non crypto-monnaie de {amount}',
      non_crypto_withdraw_unlimited: 'Retraits illimités sans crypto-monnaie',
      crypto_deposit: 'Limite annuelle de dépôts de crypto-monnaie de {amount}',
      crypto_deposit_unlimited: 'Dépôts illimités en crypto-monnaie',
      non_crypto_deposit: 'Limite annuelle des dépôts hors crypto-monnaie de {amount}',
      non_crypto_deposit_unlimited: 'Dépôts hors crypto-monnaie illimité',
    },
    your_kyc_verification: 'Votre vérification KYC',
    your_kyc_needs_an_update: 'Votre KYC doit <span class="color-update">être mis à jour</span>',
    need_update_reason: 'Malheureusement, nous n\'avons pas pu approuver votre compte pour les raisons suivantes :',
    open_support: 'Ouvrir le support ',
    your_kyc_has_been_denied: 'Votre KYC a <span class="color-denied">été refusé</span>',
    denied_description: 'Votre KYC a été refusé, vous ne pouvez donc pas procéder à une nouvelle vérification KYC.',
    deleted_description: 'Votre KYC a été refusé. Vous pouvez recommencer la procédure de vérification.',
    please_contact_our: 'Veuillez contacter notre',
    support: 'support',
    clarify_the_situation: 'pour clarifier la situation.',
    your: 'Votre',
    kyc_title: 'Know Your Customer <span class="text-cp">vérification</span>',
    verification: 'vérification',
    pending: 'est en cours',
    pending_description: 'C\'est tout ! Merci d\'avoir suivi le processus de vérification. Vos données ont été soumises avec succès. Nous ferons de notre mieux pour vérifier votre demande dès que possible. En général, cela ne prend pas plus de 12 heures. Nous vous enverrons un e-mail lorsque votre compte sera approuvé. Nous vous remercions de votre patience.',
    do_you_need_help: 'Vous avez besoin d\'aide ? Contactez notre',
    support_center: 'support',
    back_to_kyc: 'Retour à la rubrique KYC',
    go_to_home: 'Aller à la page d\'accueil',
    level_0: 'Niveau 0',
    level_1: 'Niveau 1',
    level_2: 'Niveau 2',
    limits: 'Limites',
    benefits: 'Avantages',
    requirements: 'Prérequis',
    no_requirements: 'Aucun prérequis nécessaire',
    proof_of_address: 'Justificatif de domicile',
    all_benefits_from_the_basic_level: 'Tous les avantages à partir du niveau de base',
    personal_information: 'Informations personnelles',
    identity_document: 'Pièce d\'identité',
    selfie: 'Selfie',
    all_benefits_from_level_1: 'Tous les avantages du niveau 1',
    current: 'Actuel',
    upending: 'En attente',
    update: 'Mise à jour',
    verification_blocked: 'Vérification bloquée',
    verify_now: 'Vérifier maintenant',
    you_need_to_upgrade_to_level_1: 'Vous devez passer au niveau 1',
    upgrade_to_level_1: 'Passer au niveau 1',
    upgrade_to_level_2: 'Passer au niveau 2',
    kyc_verification: 'Vérification KYC',
    kyc_verification_span: 'vérification<span class="color-primary">KYC</span> ',
    kyc_verification_required: 'Vérification KYC requise',
    everything_done: 'Tout est fait !',
    proof_of_residency: 'Justificatif de domicile',
    you_current_residential_address: 'Votre adresse de résidence actuelle',
    only_x_minutes: 'Seulement {minutes} minutes !',
    identity_verification: 'Vérification d\'identité',
    take_a_selfie: 'Prenez un selfie',
    step: 'Étape {step}',
    country_of_residence: 'Pays de résidence',
    full_name: 'Nom complet',
    date_of_birth: 'Date de naissance',
    nationality: 'Nationalité',
    choose_your_document: 'Choisissez votre document',
    choose_document_description_1: 'Choisissez le document que vous souhaitez utiliser lors de la vérification.',
    choose_document_description_2: 'Nous n\'acceptons que les documents valides délivrés par le gouvernement.',
    choose_document_description_3: 'Tout autre document ne figurant pas sur la liste seront rejeté.',
    document_number: 'Numéro du document',
    country_of_issue: 'Pays de délivrance',
    document_issue_date: 'Date d\'émission du document',
    document_expiry_date: 'Date d\'expiration du document',
    files_requirements: 'Prérequis des fichier ',
    format: '{format} ou {or} format',
    maximum_file_size: 'Taille maximale du fichier {size}',
    minimum_picture_size: 'Taille minimale de l\'image {size} pixels',
    not_accepted_documents: 'Documents non acceptés',
    expired: 'Expiré',
    edited: 'Modifié',
    black_and_white: 'Noir et blanc',
    broken_or_damaged: 'Cassé ou endommagé',
    illegible_blurred_or_reflective: 'Illisible, flou ou réfléchissant',
    cut_off_or_overcropped: 'Coupé ou mal cadré ',
    upload_front_page: 'Importer le reco',
    upload_back_page: 'Importer le verso',
    selfie_description: 'Veuillez télécharger une photo de vous avec votre carte d\'identité et un papier avec votre nom, le texte "BitSkins.com" et la date d\'aujourd\'hui.',
    example_of_correctly_taken_photo: 'Exemple de photo correctement prise',
    with_sunglasses_cap_or_mask: 'Avec des lunettes de soleil, une casquette ou un masque',
    information_covered_by_finger: 'Les informations figurant sur votre document sont couvertes par vos doigts',
    face_covered_by_document: 'Votre visage est couvert par votre document',
    out_of_focus: 'Votre visage ou votre document n\'est pas mis au point',
    upload_selfie: 'Upload selfie',
    send_level_1_kyc_request: 'Envoyer la demande de niveau 1 KYC',
    address_line_1: 'Adresse ligne 1',
    address_line_2_optional: 'Ligne d\'adresse 2 (facultatif)',
    state_or_province: 'Région ou Province',
    proof_of_residency_description: 'Veuillez importer un document prouvant l\'adresse de votre domicile actuel que vous avez fournie à l\'étape précédente. Assurez-vous que votre nom complet est visible sur le document.',
    upload_document: 'Importez vos documents',
    accepted_documents: 'Documents acceptés',
    utility_bills: 'Factures de services publics',
    bank_statements: 'Relevés bancaires',
    tax_returns: 'Déclarations fiscales',
    government_letters: 'Lettres gouvernementales',
    other_document_residential: 'Autres documents pouvant confirmer votre adresse de résidence actuelle',
    send_level_2_kyc_request: 'Envoi d\'une demande KYC de niveau 2',
    submit: 'Soumettre',
    submit_correct: 'Soumettre les informations correctes',
    next: 'Suivant',
    send_to_verify: 'Envoi pour la vérification',
    document_verification: 'Vérification du document',
    level: 'Niveau du KYC',
    please_reupload_following_photos: 'S\'il vous plait, réuploadez les photos suivantes',
    please_reupload: 'S\'il vous plait, réuploadez',
    we_need_additional_information: 'Nous avons besoin d\'informations supplémentaires',
    file_format_not_supported: 'Le format du fichier n\'est pas pris en charge.',
    the_file_is_too_big: 'Le fichier {file_name} est trop volumineux ({file_size}),<br> maximum {size_limit}.',
    field: {
      document_image_a: 'Recto de votre document',
      document_image_b: 'Verso de votre document',
      user_image: 'Votre selfie',
      address_image: 'Justificatif de domicile',
      additional_selfie: 'Ajouter un selfie',
    },
    back_to_bitskins: 'Retour vers BitSkins',
    withdrawals: 'Retraits',
    get_to_the_next_level: 'Passez au niveau suivant pour vous débarrasser<br> des limites et accéder<br> à de nouveaux moyens de paiement.',
    after_the_first_page_is_validated: 'Une fois la première photo validée, vous pourrez importer la deuxième page.',
    accepted: 'Accepté',
  },
  camera: {
    cancel: 'Annuler',
    check_permissions: 'Vérifier les permissions',
    take_a_new_photo: 'Prendre une nouvelle photo',
    take_a_photo: 'Prendre une photo',
    use_camera: 'Utiliser la caméra',
    use_photo: 'Utiliser la photo',
    we_will_need_access_to_your_camera: 'Nous avons besoin d\'accéder à votre caméra pour continuer',
    please_follow_these_steps: 'S\'il vous plait, suivez ces étapes',
    select_the_camera_icon: 'Sélectionnez <strong>l\'icône camera</strong> dans votre barre d\'adresse',
    select_always_allow_access: 'Sélectionnez<strong>toujours autoriser l\'accès à votre appareil photo</strong>',
    select_done: 'Sélectionner  <strong>Terminé</strong>',
  },
  review: {
    leave_a_review: 'Laisser un avis',
    our_reviews: 'Nos avis',
    if_youre_happy: 'Si vous <span class="color-primary">êtes satisfait</span> du service, ',
    we_would_appreciate: 'nous vous serions reconnaissants de bien vouloir laisser un  <span class="color-primary">avis sur Trustpilot</span>  afin de nous faire part de votre expérience. Nous vous en remercions.',
    if_youre_happy_we_would_appreciate: 'Si vous <span class="color-primary"> êtes satisfait</span> du service, nous vous serions reconnaissants de nous laisser  <span class="color-primary">un avis sur Trustpilot</span> pour nous faire part de votre expérience. Nous vous en remercions.',
  },
  support: {
    center: 'Support',
    tickets_list: 'Liste des tickets',
    create_ticket: 'Créer un ticket',
    submit_ticket: 'Envoyez le ticket',
    close_ticket: 'Fermer le ticket',
    submit_disclaimer: 'Pour accélérer notre travail et recevoir une réponse le plus rapidement possible, veillez à ne pas ouvrir plusieurs tickets concernant le même problème. Le temps de réponse moyen est de <strong>plusieurs heures</strong>. Vous pouvez nous contacter en <strong> anglais, en polonais et en suédois</strong>. Nous vous remercions de votre coopération.',
    enter_your_message: 'Saisissez votre message',
    new_ticket: 'Nouveau ticket',
    your_ticket: 'Votre ticket',
    bitskins_team: 'Équipe BitSkins',
    ticket_has_been_closed_by: 'Le ticket a été <span>fermé</span> par <span>{by}</span>',
    ticket_has_been_closed: 'Le ticket a été <span>fermé</span>',
    conversation_history: 'Historique de la conversation :',
    your_reply: 'Votre réponse...',
    last_reply_by: 'Dernière réponse par',
    send: 'Envoyer',
    ticket: 'Ticket',
    title: 'Titre',
    category: {
      payments: 'Paiements',
      payment_crypto_deposit: 'Dépôt en crypto-monnaie',
      payment_crypto_withdraw: 'Retrait en crypto-monnaie',
      payment_standard_deposit: 'Méthode de dépôt standard',
      payment_standard_withdraw: 'Méthode de retrait standard',
      market: 'Marché',
      market_item_issue: 'Problème avec l\'item',
      market_buy_orders: 'Ordre d\'achat',
      market_bulk_buy: 'Achat groupé',
      market_missing_screenshot: 'Capture d\'écran manquante',
      market_missing_float: 'Float manquant',
      market_wrong_price: 'Prix Steam manquant',
      market_other: 'Autre',
      trading: 'Trades',
      trading_deposit: 'Dépôt d\'item',
      trading_withdraw: 'Retrait d\'item',
      account: 'Compte',
      account_2fa: 'problème A2F',
      account_email: 'Problème d\'e-mail',
      account_kyc: 'KYC',
      account_affiliate: 'Système d\'affiliation',
      account_restrictions: 'Restrictions',
      account_other: 'Autre',
      other: 'Autre',
      bug_report: 'Signaler un bug',
      api: 'API',
      suggestions: 'Suggestions',
      business_inquiry: 'Demande commerciale',
      general_inquiry: 'Demande générale',
    },
    extra: {
      txid_url: 'TXID/url',
      amount: 'Montant',
      crypto: 'Crypto-monnaie',
      disclaimer_visa_1: 'Veuillez garder à l\'esprit qu\'il est normal que cela puisse prendre jusqu\'à 5 jours ouvrables avant que l\'argent ne soit disponible sur votre compte bancaire.',
      disclaimer_visa_2: 'Assurez vous que c\'est une carte Visa et non une Mastercard vers laquelle vous tentez de retirer. Nous ne prenons actuellement pas en charge les retraits vers les cartes Mastercard.',
      card_digits: '4 derniers chiffres de votre carte',
      binance_id: 'Votre Binance ID',
      wallet_address: 'Adresse de votre portefeuille',
      provider: 'Fournisseur',
      transaction_id: 'ID de la transaction',
      type: 'Type',
      method: 'Méthode',
      item_link: 'Lien de l\'item',
      bot_received_item: 'Un lien vers le profil Steam du bot qui a reçu vos items',
      trade_offer_id: 'ID de l\'offre d\'échange',
      can_be_found_here: 'peut être trouvé ici',
      email: 'Entrez l\'e-mail',
    },
  },
  service: {
    market: {
      buy: 'Acheter',
      sell: 'Vendre',
      fee: 'Frais de vente',
      buy_order: 'Ordre d\'achat',
      bargain: 'Bonne affaire',
      instant_sell: 'Vente instantanée',
      bump: 'Boost',
      bump_package: 'Pack de boost',
    },
    deposit: {
      gift_code: 'Carte cadeau',
      bitcoin: 'Dépôt BTC',
      litecoin: 'Dépôt LTC',
      ethereum: 'Dépôt ETH',
      unlimint: 'Dépôt par carte bancaire',
      binance_pay: 'Dépôt avec Binance Pay',
      binancepay: 'Dépôt avec Binance Pay',
      available_coupons: 'Coupons disponibles :',
      redeem_coupon: 'Utiliser un coupon',
      enter_coupon_code: 'Saisissez le code coupon',
      open_binance_website: 'Ouvrir le site de Binance',
      list_of_active_transactions: 'Liste des transactions actives :',
      transaction_needs_at_least_x_confirmations: 'La transaction nécessite au moins {x} confirmations avant que les fonds n\'apparaissent sur votre compte.',
      billing_information: 'Informations de <span class="text-cp">facturation</span>',
      coupon: {
        coupon: 'Coupon',
        make_a_gift: 'Offrez-vous ou offrez à quelqu\'un <span class="text-cp">un cadeau</span>',
        bitskins_coupons_are_a_good_alternative: 'Les coupons BitSkins sont une bonne alternative aux méthodes de paiement standard et une excellente idée de cadeau. Vous pouvez les acheter auprès de nos partenaires qui proposent de nombreux moyens de paiement.',
        dont_wait: '<span class="text-cp">Ne tardez pas et rechargez votre solde</span> avec un coupon BitSkins ou faites <span class="text-cp">un cadeau original</span> à quelqu\'un<br> (nous connaissons tous quelqu\'un avec un inventaire vide).',
        kinguin: 'Kinguin (nouveaux frais réduits)',
      },
      crypto: {
        get_wallet_address: 'Obtenir l\'adresse du portefeuille',
        your_wallet_address: 'Adresse de votre portefeuille',
        this_address_is_only_for_x: 'Cette adresse est uniquement pour les dépôts de {x}. Ne pas envoyer d\'autres crypto-monnaies à cette adresse.',
        this_address_will_not_expire: 'Cette adresse n\'expire pas. Vous pouvez l\'utiliser à tout moment.',
        choose_alternative_address: 'Choisir une adresse alternative',
        the_acutal_amount_you_will_be_credited: 'Le montant réel qui vous sera crédité dépend du prix {x} au moment où nous recevons votre paiement.',
        only_l1_transactions: '<span class="text-cy">Seules les transactions de niveau L1 sont prises en charge. Ne pas utiliser les transactions internes et les contrats intelligents !</span>',
      },
      zen: {
        zen: 'Dépôt avec ZEN',
        deposit_started: 'Le dépôt avec ZEN a commencé, ',
        open_the_zen_deposit_page: 'ouvrir la page de dépôt ZEN',
        processing_fee: 'ZEN ajoutera à la transaction des frais de traitement qui dépendent de la méthode de paiement sélectionnée.<br> Le montant final de la transaction sera visible sur leur site web.',
        each_transaction_is_reviewed: 'Chaque transaction est examinée par ZEN Pay et peut prendre <span class="text-cp">entre une minute et quelques heures</span> pour être complétée.',
      },
      the_minimum_deposit_amount_is: 'Le montant minimum de dépôt est de {amount}.',
      the_maximum_deposit_amount_is: 'Le montant maximum du dépôt est de {amount}.',
    },
    withdraw: {
      only_binance_com_is_supported: '<span class="text-cy">Nous proposons des paiements uniquement vers binance.com (binance.us n\'est pas pris en charge).</span>',
      bitcoin: 'Retrait en BTC',
      litecoin: 'Retrait en LTC',
      ethereum: 'Retrait en ETH',
      unlimint: 'Retrait vers une carte VISA',
      tipalti: {
        tipalti: 'Retrait avec Tipalti',
        tipalti_allows_you_to_withdraw: 'Tipalti vous permet de retirer vos fonds sur votre compte bancaire et PayPal.',
        you_dont_have_a_tipalti_acount: 'Vous n\'avez pas de compte Tipalti ?',
        you_have_to_create_an_account: 'Pour retirer vos fonds par l\'intermédiaire de Tipalti, vous devez d\'abord créer un compte sur leur site web.<br> Vous pouvez le faire en cliquant sur le bouton ci-dessous.',
        create_tipalti_account: 'Créer un compte Tipalti',
        check_your_email: 'Veuillez vérifier <span class="text-cp">vos e-mail</span> et cliquer sur le lien de confirmation pour finaliser la création de votre compte. Si vous ne trouvez pas le message dans votre boîte de réception, veuillez vérifier votre dossier de courriers indésirables (spam).',
        payment_method: 'Mode de paiement',
        tipalti_panel: 'Panneau de contrôle de Tipalti',
        tipalti_payouts_incur_a_fee: 'Les paiements en Tipalti entraînent des frais qui peuvent s\'élever jusqu\'à 26$. Les frais dépendent de la méthode de paiement sélectionnée. Vous trouverez ci-dessous un tableau indiquant les frais pour chaque méthode de paiement.',
        fee_per_payment: 'Frais par paiement',
        rejection_fee: 'Frais de rejet',
        echeck_local: 'Chèque électronique (local)',
        paypal_non_us: 'PayPal (résidents non américains)',
        paypal_us: 'PayPal (résidents américains)',
        wire_transfer_non_us_non_usd: 'Virement bancaire (pour les résidents non américains, le paiement est effectué en devises autres que l\'USD)',
        wire_transfer_non_us_usd: 'Virement bancaire (résident non américain payé en USD)',
        wire_transfer_us: 'Virement bancaire (résident américain)',
        up_to_21_usd: 'jusqu\'à 21,00$',
        up_to_2_usd: 'jusqu\'à 2,00$',
      },
      payoneer: 'Retrait avec Payoneer',
      binance_pay: 'Retrait avec Binance Pay',
      binancepay: 'Retrait avec Binance Pay',
      p2p: 'Transfert P2P',
      payouts_are_performed_on_a_rolling_basis: 'Les paiements sont effectués sur une base continue jusqu\'à 5 minutes après leur demande.',
      your_payout_will_be_processed_at_the_current_rate: 'Votre paiement sera traité au taux actuel.',
      please_verify_the_wallet_address: 'Veuillez vérifier l\'adresse du portefeuille. Nous ne pouvons pas rembourser un retrait incorrect.',
      the_data_controller: 'La personne responsable du traitement des données et partie contractante avec Unlimint pour les paiements traités par eux est Bitskins Sp. z o.o., dont le siège social est situé à 40-246 Katowice, Porcelanowa str. 23, Pologne, enregistrée sous le numéro : 0000810143. Vous pouvez trouver plus de détails dans la Politique de Confidentialité et les Conditions d\'Utilisation.',
      visa_withdrawals_are_processed_instantly: 'Les retraits par carte VISA sont traités instantanément. Toutefois, dans certains cas, il peut s\'écouler plusieurs jours avant que l\'argent n\'apparaisse sur votre compte bancaire.',
      card_info: 'Informations sur la carte',
      ccv: 'CVC',
      add_new_deposit_needed: 'Ajouter un nouveau (dépôt nécessaire)',
      you_can_have_max_3_bank_cards: 'Vous pouvez avoir au maximum trois cartes bancaires affectées à votre compte.',
      your_cards_amount: '<span class="text-cp">Vos</span> cartes ({x}/3)',
      the_minimum_withdraw_amount_is_x: 'Le montant minimum de retrait est de {x}.',
      the_maximum_withdraw_amount_is_x: 'Le montant maximum de retrait est de {x}.',
      enter_amount: 'Saisir le montant',
      go_to_card_deposit: 'Aller au dépôt par carte',
      to_be_able_to_withdraw_your_funds_you_need_to_verify_your_card: 'Pour pouvoir retirer vos fonds, vous devez d\'abord vérifier votre carte. Vous pouvez le faire en déposant 1$.',
      deposited_funds_are_non_withdrawable: 'N\'oubliez pas que les fonds déposés ne peuvent pas être retirés et qu\'ils ne peuvent être utilisés que pour des achats.',
      we_do_not_support_mastercard_withdrawals: 'Nous ne prenons pas en charge les retraits sur les cartes MasterCard et sur les cartes émises dans les pays suivants : Bosnie-Herzégovine, Canada, Égypte, Japon, Cambodge, Corée (du Sud), KOSOVO, Macédoine du Nord, États-Unis d\'Amérique, Argentine.',
      your_card_is_valid_until: 'Votre carte est valable jusqu\'au 16.02.2023, 15:35 (UTC). Passé ce délai, vous devrez revérifier votre carte en déposant 5$.',
      card_verification_required: '<span class="text-cp">Vérification de la carte</span> requise',
      card: 'Carte',
      add_new_card: '<span class="text-cp">Ajouter</span> une nouvelle carte',
      how_to_find_my_binance_id: 'Comment trouver mon ID utilisateur (BUID) sur Binance ?',
      how_to_find_my_pay_id: 'Comment trouver mon Pay ID sur Binance ?',
      how_to_find_my_email: 'Comment trouver mon e-mail sur Binance ?',
      binance_id: 'Identifiant Binance',
      receiver_type: 'Type de receveur',
      i_do_not_have_a_binance_account: 'Je n\'ai pas de compte Binance',
      i_have_a_binance_account: 'J\'ai un compte Binance',
      binance_account: 'Compte <span class="text-cp">Binance</span>',
      the_fee_is_already_included_in_the_current_x_rate: 'La taxe de {fee}% est déjà incluse dans le taux actuel de {x}.',
    },
    wallet: {
      transfer: 'Transfert de fonds',
      refund: 'Remboursement des fonds',
      available_payment_methods: 'Modes de paiement disponibles',
      bank_cards: 'Cartes bancaires',
      kyc_required_for_this_payment_method: 'Vous ne pouvez pas utiliser ce mode de paiement car vous n\'avez pas suivi la procédure KYC. Vous pouvez dès maintenant commencer le processus de vérification.',
      kyc_limit_exceeded: 'Vous ne pouvez pas utiliser ce mode de paiement car vous avez dépassé la limite de transaction correspondant à votre niveau KYC. Vous pouvez maintenant lancer la procédure de vérification pour lever les restrictions.',
      no_limit: 'Pas de limite',
      limits_info: 'Sur Bitskins <strong>chaque transaction dispose de son propre minuteur et de sa propre limite, qui sont réinitialisés un an après la transaction</strong>. Les montants maximums que vous pouvez déposer ou retirer sont indiqués dans les tableaux. Vous pouvez augmenter les limites ou vous en débarrasser complètement en passant par la procédure KYC.',
      crypto_deposits: 'Dépôt en crypto-monnaie',
      crypto_withdrawals: 'Retraits en crypto-monnaie',
      standard_deposits: 'Dépôt standard',
      standard_withdrawals: 'Retraits standard',
      coupons_are_excluded_from_the_limit: '* les coupons sont exclus de la limite',
      x_type_does_not_incur_any_fees: '{x} {type} n\'engendre aucun frais.',
      incur_fees_of: 'encourent des frais d\'un montant de',
      plus: 'plus',
      the_minimum_type_amount_is: 'Le montant <span class="color-primary">minimum {type}</span> est de',
      the_maximum_type_amount_is: 'Le montant <span class="color-primary">maximum {type}</span> est de',
      due_to_unstable_crypto_network: 'En raison de l\'instabilité du réseau de crypto-monnaie, des retards peuvent survenir.',
      binance_temporarily_disabled: 'Les retraits avec Binance sont désactivés jusqu\'au lundi (28.08.2023)',
    },
  },
  enum: {
    report_type: {
      balance: 'Solde',
      sell: 'Vendu',
      buy: 'Acheté',
    },
    report_status: {
      empty: 'Vide',
      pending: 'En attente',
      done: 'Terminé',
    },
    autobump_period: {
      hour_1: '1h',
      hour_3: '3h',
      hour_6: '6h',
      hour_12: '12h',
      hour_24: '24h',
      hour_48: '48h',
    },
    autobump_status: {
      not_enough_bumps: 'Pas assez de boosts',
      finished: 'Terminé',
      cancelled: 'Annulé',
      pending: 'En attente',
      active: 'Actif',
    },
    inventory_status: {
      issue: 'Problème',
      not_available: 'Non disponible',
      deleted: 'Retirer de la vente',
      withdrawn: 'Retiré',
      delisted: 'Retirer de la vente',
      ready: 'Prêt',
      listed: 'Mettre en vente',
      listed_private: 'Mettre en vente privée',
      sold: 'Vendu',
      withdraw_queue: 'Rentrait en file d\'attente',
      withdraw_pending: 'Retrait en attente',
      instant_sell: 'Vente instantanée',
    },
    service: {
      market: {
        buy: 'Acheter',
        sell: 'Vendre',
        fee: 'Frais de vente',
        buy_order: 'Ordre d\'achat',
        bargain: 'Négocier',
        instant_sell: 'Vente instantanée',
        bump: 'Boost',
        bump_package: 'Pack de boost',
      },
      deposit: {
        bitcoin: 'Dépôt BTC',
        litecoin: 'Déposer LTC',
        ethereum: 'Déposer ETH',
        unlimint: 'Dépôt par carte bancaire',
        zen: 'Dépôt avec ZEN',
        gift_code: 'Carte cadeau',
        binancepay: 'Dépôt avec Binance Pay',
      },
      withdraw: {
        bitcoin: 'Retrait BTC',
        litecoin: 'Retrait LTC',
        ethereum: 'Retrait ETH',
        unlimint: 'Retrait vers une carte VISA',
        tipalti: 'Retrait avec Tipalti',
        payoneer: 'Retrait avec Payoneer',
        binancepay: 'Retrait avec Binance Pay',
        p2p: 'Transfert P2P',
      },
      wallet: {
        transfer: 'Transfert de fonds',
        refund: 'Remboursement des fonds',
      },
      marketing: {
        coupon: 'Bon de réduction',
        referral: 'Filleul',
        affiliate: 'Affiliation',
      },
    },
  },
  meta: {
    default_title: 'BitSkins 2024',
    default_description: 'BitSkins offre une plateforme fluide pour acheter et vendre vos items CS2, DOTA2, TF2, RUST. Explorez une vaste sélection de fusils, couteaux, gants, et plus encore. Rejoignez-nous dès maintenant pour échanger en toute simplicité !',
    home_title: 'BitSkins.com - Achat & Vente de Skins CS2. Trade Rapide, Facile & Sécurisé',
    home_description: 'BitSkins offre une plateforme fluide pour acheter et vendre vos items CS2, DOTA2, TF2, RUST. Explorez une vaste sélection de fusils, couteaux, gants, et plus encore. Rejoignez-nous dès maintenant pour échanger en toute simplicité !',
    support_title: 'Support BitSkins : Obtenez de l\'aide pour votre commerce CS2',
    support_description: 'Besoin d\'aide pour vos échanges avec CS2 ? Visitez la page de support de BitSkins pour obtenir une aide rapide. Notre équipe est là pour répondre à vos questions, résoudre les problèmes et vous guider.',
    item_title: '{item} - {game} Skins | Trouvez et Échangez les {game} items de votre choix',
    item_description_csgo: 'Découvrez et échangez vos skins CS2 préférés sur BitSkins. Explorez notre vaste collection de fusils, de couteaux, de gants et bien plus encore. Achetez, vendez ou retirez instantanément. Commencez à naviguer dès maintenant !',
    item_description_cs2: 'Découvrez et échangez vos skins CS2 préférés sur BitSkins. Explorez notre vaste collection de fusils, de couteaux, de gants et bien plus encore. Achetez, vendez ou retirez instantanément. Commencez à naviguer dès maintenant !',
    item_description_dota2: 'Découvrez et échangez les skins DOTA2 de votre choix sur BitSkins. Explorez notre vaste collection de wards, de musiques, de bundles, et plus encore. Achetez, vendez ou retirez instantanément. Commencez à naviguer dès maintenant !',
    item_description_tf2: 'Découvrez et échangez vos items TF2 préférés sur BitSkins. Explorez notre vaste collection de cosmétiques, de taunts, de caisses et bien plus encore. Achetez, vendez ou retirez instantanément. Commencez à naviguer dès maintenant !',
    item_description_rust: 'Découvrez et échangez vos items RUST sur BitSkins. Explorez notre vaste collection de vêtements, d\'armes, de ressources et bien plus encore. Achetez, vendez ou retirez instantanément. Commencez à naviguer dès maintenant !',
    market_title: 'Marché BitSkins : Explorer et échanger des items {game} en toute Simplicité',
    market_description_csgo: 'Entrez dans le marché BitSkins pour explorer et échanger une large gamme d\'items CS2 sans effort. Découvrez les meilleures offres sur les skins, les clés, les capsules et bien plus encore. Achetez, vendez ou retirez instantanément.',
    market_description_cs2: 'Entrez dans le marché BitSkins pour explorer et échanger une large gamme d\'items CS2 sans effort. Découvrez les meilleures offres sur les skins, les clés, les capsules et bien plus encore. Achetez, vendez ou retirez instantanément.',
    market_description_dota2: 'Entrez dans le marché BitSkins pour explorer et échanger une large gamme d\'items DOTA2 sans effort. Découvrez les meilleures offres sur les wards, les musiques, les bundles, et plus encore. Achetez, vendez ou retirez instantanément.',
    market_description_tf2: 'Entrez dans le marché BitSkins pour explorer et échanger une large gamme d\'items TF2 sans effort. Découvrez les meilleures offres sur les cosmétiques, les taunts, les caisses et bien plus encore. Achetez, vendez ou retirez instantanément.',
    market_description_rust: 'Entrez dans le marché BitSkins pour explorer et échanger une large gamme d\'items RUST sans effort. Découvrez les meilleures offres sur les vêtements, les armes, les ressources et bien plus encore. Achetez, vendez ou retirez instantanément.',
    market_item_title: 'Marché BitSkins : {skin} : {game} Marché',
    store_title: 'Boutique Utilisateur BitSkins : {alias} - {game} Vitrine Items',
    store_description: 'Boutique Utilisateur BitSkins pour présenter et vendre vos items. Fixez vos prix, dialoguez avec les acheteurs et établissez votre présence au sein de la communauté trading.',
    login_title: 'Connexion BitSkins : Accès sécurisé à votre compte de trading CS2',
    login_description: 'Connectez-vous à votre compte BitSkins en toute sécurité. Accédez à votre inventaire CS2, gérez vos items, effectuez des transactions et profitez d\'une expérience commerciale sans faille.',
    steam_login_title: 'Connexion avec Steam',
    profile_title: 'Paramètres du compte',
    wallet_title: 'Vos fonds BitSkins',
    affiliate_title: 'Panneau d\'affiliation BitSkins : Gagnez des récompenses pour vos parrainages',
    affiliate_description: 'Rejoignez le programme d\'affiliation BitSkins et gagnez des récompenses en parrainant des passionnés de skins. Bénéficiez d\'un programme d\'affiliation lucratif, suivez vos filleuls et maximisez vos gains.',
    statistics_title: 'Statistiques de Vente BitSkins : Découvrez les Tendances & Perspectives du Marché',
    statistics_description: 'Explorez des statistiques complètes sur BitSkins pour obtenir des informations précieuses sur les tendances de trading CS2. Analysez les données du marché, la popularité des items, et bien plus encore pour optimiser vos stratégies de trading.',
    sales_fees_title: 'Frais de Vente BitSkins : Une Tarification Transparente pour Vos Ventes CS2',
    sales_fees_description: 'Comprenez clairement la structure des frais de vente de BitSkins. Nos frais transparents garantissent l\'équité et la simplicité de vos ventes de CS2. En savoir plus.',
    checkout_title: 'Panier BitSkins : Paiement pratique pour les items CS2',
    checkout_description: 'Simplifiez votre expérience de trading CS2 avec le Panier BitSkins. Gérez facilement vos items, vérifiez votre commande et procédez au paiement sécurisé. Profitez d\'un processus de trading fluide dès aujourd\'hui !',
    steam_inventory_title: 'Mon inventaire {game} Steam',
    bs_inventory_title: 'Mon inventaire {game} BitSkins',
    selling_inventory_title: 'Mes items listés dans {game}',
    buy_order_create_title: 'Création d\'ordres d\'achat pour {game} ',
    buy_order_active_title: 'Ordres d\'achat actifs pour {game}',
    buy_order_title: 'Ordres d\'achat pour {game}',
    trades_active_title: 'Trades actifs',
    trades_history_title: 'Historique des trades',
    transactions_title: 'Transactions',
    favorites_title: 'Items Favoris',
    kyc_title: 'Formulaire de demande de Know Your Customer (KYC)',
    tos_title: 'Conditions d\'Utilisation de BitSkins : Lignes Directrices pour des Trades Sûr & Fiable',
    tos_description: 'Consultez nos conditions d\'utilisation pour des échanges sûrs et fiables. Familiarisez-vous avec nos politiques et nos obligations. Effectuez des transactions en toute sécurité sur BitSkins.',
    privacy_policy_title: 'Politique de Confidentialité de BitSkins : Protection de Vos Informations Personnelles',
    privacy_policy_description: 'Lisez la Politique de Confidentialité de BitSkins pour savoir comment nous protégeons et traitons vos informations personnelles. La confiance et la transparence sont au cœur de notre engagement.',
    cookie_policy_title: 'BitSkins Politique de Cookies : Votre Vie Privée Nous Importe',
    cookie_policy_description: 'Chez BitSkins, nous respectons votre vie privée. Lisez notre politique en matière de cookies pour comprendre comment nous utilisons les cookies et autres technologies similaires. Votre confiance et la sécurité de vos données sont nos principales priorités.',
    docs_v1_title: 'API BitSkins V1 : Ancienne Version de l\'API',
    docs_v1_description: 'Intégrez l\'API V1 de BitSkins pour des échanges fluides. Accédez à la documentation pour optimiser vos capacités de trading. Passez à la dernière version pour bénéficier de nouvelles fonctionnalités.',
    docs_v2_title: 'BitSkins API V2 : La Nouvelle Version de l\'API',
    docs_v2_description: 'Débloquez de nouvelles fonctionnalités avec l\'API V2 de BitSkins. Améliorez vos stratégies de trading et votre efficacité. Explorez notre documentation complète dès maintenant !',
    docs_migration_title: 'Migration de l\'API BitSkins : Transition Fluide vers la Nouvelle API',
    docs_migration_description: 'Migrez sans faille vers la nouvelle API de BitSkins avec l\'aide de notre guide complet.\nExplorez les fonctionnalités mises à jour et les processus d\'intégration pour une expérience de trading améliorée.',
  },
  alt: {
    envelope: 'Enveloppe',
    app_store: 'App Store',
    google_store: 'Google Play',
  },
  time: {
    seconds: 'secondes',
  },
  calendar: {
    week: 'Semaine',
    month: 'Mois',
    lifetime: 'Durée de vie',
  },
  docs: {
    docs: 'Docs',
    api: 'API',
    api_v1: 'API V1 (Passerelle)',
    api_v2: 'API V2',
    api_migration_guide: 'Guide de migration de l\'API',
    request_parameters: 'Paramètres de la requête',
    sample_request: 'Exemple de requête',
    sample_response: 'Exemple de réponse',
    request_schema: 'Schéma de la requête',
    enums: 'ENUMS',
  },
  wallet: {
    coupon_redeemed: 'Vous avez utilisé un coupon de {amount}',
    balance_changed: 'Le solde a été mis à jour',
    transfer_p2p_confirm: 'Confirmer le transfert de fonds vers p2p.bitskins.com',
    transfer_p2p_confirm_needed: 'Vous devez confirmer le transfert',
    transfer_p2p_success: 'Vos fonds ont été transférés vers p2p.bitskins.com',
    transfer_funds: 'Transférer des fonds',
    deposit_started: 'Dépôt commencé',
    card_removed: 'Carte retirée',
    confirm_card_remove: 'Êtes-vous sûr de vouloir retirer cette carte ?',
    delete_card: 'Supprimer une carte',
    deposit: 'dépôt',
    withdraw: 'retirer',
    security_code: 'Code de sécurité',
    security_code_ccv: 'Code de sécurité',
    card_number: 'Numéro de carte',
    full_name: 'Nom complet',
    month_expired: 'Date d\'expiration (MM/YYYY)',
    addr_line_1: 'Adresse de facturation (ligne 1)',
    addr_line_2: 'Adresse de facturation (ligne 2)',
    zip: 'Code postal ou ZIP',
    city: 'Ville',
    country: 'Pays',
    withdraw_only_to_visa: 'Seuls les retraits sur une carte Visa sont autorisés',
    card_country_is_restricted: 'Malheureusement, nous n\'effectuons pas de retraits sur les cartes émises dans les pays suivants {country}',
  },
  twofa: {
    required: 'Authentification à deux facteurs requise',
    required_for_this_payment_method: 'Vous ne pouvez pas utiliser ce mode de paiement car vous n\'avez pas configuré l\'authentification à deux facteurs.',
    you_can_start_now: 'Vous pouvez désormais commencer le processus de configuration.',
    setup: 'Authentification A2F',
    why_we_require: 'Cliquez pour lire - Pourquoi exigeons nous A2F pour les retraits ?',
  },
  password_strong: {
    minimum: 'Le mot de passe doit comporter au moins {value} caractères',
    maximum: 'Le mot de passe doit comporter au maximum {value} caractères',
    lowercase: 'Le mot de passe doit comporter au moins 1 caractère minuscule',
    uppercase: 'Le mot de passe doit comporter au moins 1 caractère majuscule',
    numeric: 'Le mot de passe doit comporter au moins 1 caractère numérique',
    special: 'Le mot de passe doit comporter au moins 1 caractère spécial',
  },
  help_center: {
    help_center: 'Centre d\'aide',
    hello: 'Bonjour, comment pouvons-nous vous aider ?',
    create_ticket: 'créer un ticket',
    contact_us: 'Contactez-nous',
    guide: 'Guide',
    top_articles: 'Meilleurs articles',
    didnt_find: 'Vous n\'avez pas trouvé ce que vous cherchiez ?',
    article: 'Articles',
    general: 'Général',
    fees: 'Frais',
    buying_selling: 'Acheter & Vendre',
    deposit_withdrawal: 'Dépôts & Retraits',
    refunds: 'Remboursements',
    user_account: 'Compte Utilisateur',
    affiliate: 'Affiliation',
    partnership: 'Partenariat',
    scam: 'Soupçon d\'escroquerie',
    was_helpful: 'Cet article a-t-il été utile ?',
    found_helpful: '{yes} sur {max} ont trouvé cela utile',
    faq: 'Questions <span class="color-primary">fréquemment</span> posées',
  },
};
